import { jsx as P, jsxs as Nt, Fragment as uo } from "react/jsx-runtime";
import H, { createElement as _t } from "react";
import ao from "react-dom";
const we = 0, zt = 1, qt = 2, kn = 4;
function un(t) {
  return () => t;
}
function fo(t) {
  t();
}
function ne(t, e) {
  return (n) => t(e(n));
}
function an(t, e) {
  return () => t(e);
}
function mo(t, e) {
  return (n) => t(e, n);
}
function We(t) {
  return t !== void 0;
}
function po(...t) {
  return () => {
    t.map(fo);
  };
}
function Yt() {
}
function ve(t, e) {
  return e(t), t;
}
function ho(t, e) {
  return e(t);
}
function X(...t) {
  return t;
}
function K(t, e) {
  return t(zt, e);
}
function G(t, e) {
  t(we, e);
}
function Ge(t) {
  t(qt);
}
function ot(t) {
  return t(kn);
}
function O(t, e) {
  return K(t, mo(e, we));
}
function Tt(t, e) {
  const n = t(zt, (o) => {
    n(), e(o);
  });
  return n;
}
function dn(t) {
  let e, n;
  return (o) => (r) => {
    e = r, n && clearTimeout(n), n = setTimeout(() => {
      o(e);
    }, t);
  };
}
function Fn(t, e) {
  return t === e;
}
function Y(t = Fn) {
  let e;
  return (n) => (o) => {
    t(e, o) || (e = o, n(o));
  };
}
function A(t) {
  return (e) => (n) => {
    t(n) && e(n);
  };
}
function E(t) {
  return (e) => ne(e, t);
}
function Rt(t) {
  return (e) => () => {
    e(t);
  };
}
function S(t, ...e) {
  const n = go(...e);
  return (o, r) => {
    switch (o) {
      case qt:
        Ge(t);
        return;
      case zt:
        return K(t, n(r));
    }
  };
}
function bt(t, e) {
  return (n) => (o) => {
    n(e = t(e, o));
  };
}
function Dt(t) {
  return (e) => (n) => {
    t > 0 ? t-- : e(n);
  };
}
function kt(t) {
  let e = null, n;
  return (o) => (r) => {
    e = r, !n && (n = setTimeout(() => {
      n = void 0, o(e);
    }, t));
  };
}
function N(...t) {
  const e = new Array(t.length);
  let n = 0, o = null;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, (c) => {
      const a = n;
      n = n | l, e[i] = c, a !== r && n === r && o && (o(), o = null);
    });
  }), (s) => (i) => {
    const l = () => {
      s([i].concat(e));
    };
    n === r ? l() : o = l;
  };
}
function go(...t) {
  return (e) => t.reduceRight(ho, e);
}
function Io(t) {
  let e, n;
  const o = () => e == null ? void 0 : e();
  return function(r, s) {
    switch (r) {
      case zt:
        return s ? n === s ? void 0 : (o(), n = s, e = K(t, s), e) : (o(), Yt);
      case qt:
        o(), n = null;
        return;
    }
  };
}
function w(t) {
  let e = t;
  const n = $();
  return (o, r) => {
    switch (o) {
      case we:
        e = r;
        break;
      case zt: {
        r(e);
        break;
      }
      case kn:
        return e;
    }
    return n(o, r);
  };
}
function ct(t, e) {
  return ve(w(e), (n) => O(t, n));
}
function $() {
  const t = [];
  return (e, n) => {
    switch (e) {
      case we:
        t.slice().forEach((o) => {
          o(n);
        });
        return;
      case qt:
        t.splice(0, t.length);
        return;
      case zt:
        return t.push(n), () => {
          const o = t.indexOf(n);
          o > -1 && t.splice(o, 1);
        };
    }
  };
}
function ht(t) {
  return ve($(), (e) => O(t, e));
}
function U(t, e = [], { singleton: n } = { singleton: !0 }) {
  return {
    constructor: t,
    dependencies: e,
    id: So(),
    singleton: n
  };
}
const So = () => Symbol();
function xo(t) {
  const e = /* @__PURE__ */ new Map(), n = ({ constructor: o, dependencies: r, id: s, singleton: i }) => {
    if (i && e.has(s))
      return e.get(s);
    const l = o(r.map((c) => n(c)));
    return i && e.set(s, l), l;
  };
  return n(t);
}
function rt(...t) {
  const e = $(), n = new Array(t.length);
  let o = 0;
  const r = Math.pow(2, t.length) - 1;
  return t.forEach((s, i) => {
    const l = Math.pow(2, i);
    K(s, (c) => {
      n[i] = c, o = o | l, o === r && G(e, n);
    });
  }), function(s, i) {
    switch (s) {
      case qt: {
        Ge(e);
        return;
      }
      case zt:
        return o === r && i(n), K(e, i);
    }
  };
}
function V(t, e = Fn) {
  return S(t, Y(e));
}
function Le(...t) {
  return function(e, n) {
    switch (e) {
      case qt:
        return;
      case zt:
        return po(...t.map((o) => K(o, n)));
    }
  };
}
var mt = /* @__PURE__ */ ((t) => (t[t.DEBUG = 0] = "DEBUG", t[t.INFO = 1] = "INFO", t[t.WARN = 2] = "WARN", t[t.ERROR = 3] = "ERROR", t))(mt || {});
const To = {
  0: "debug",
  3: "error",
  1: "log",
  2: "warn"
}, Co = () => typeof globalThis > "u" ? window : globalThis, Vt = U(
  () => {
    const t = w(
      3
      /* ERROR */
    );
    return {
      log: w((n, o, r = 1) => {
        var i;
        const s = (i = Co().VIRTUOSO_LOG_LEVEL) != null ? i : ot(t);
        r >= s && console[To[r]](
          "%creact-virtuoso: %c%s %o",
          "color: #0253b3; font-weight: bold",
          "color: initial",
          n,
          o
        );
      }),
      logLevel: t
    };
  },
  [],
  { singleton: !0 }
);
function Ht(t, e, n) {
  return _e(t, e, n).callbackRef;
}
function _e(t, e, n) {
  const o = H.useRef(null);
  let r = (i) => {
  };
  const s = H.useMemo(() => typeof ResizeObserver < "u" ? new ResizeObserver((i) => {
    const l = () => {
      const c = i[0].target;
      c.offsetParent !== null && t(c);
    };
    n ? l() : requestAnimationFrame(l);
  }) : null, [t, n]);
  return r = (i) => {
    i && e ? (s == null || s.observe(i), o.current = i) : (o.current && (s == null || s.unobserve(o.current)), o.current = null);
  }, { callbackRef: r, ref: o };
}
function On(t, e, n, o, r, s, i, l, c) {
  const a = H.useCallback(
    (m) => {
      const x = wo(m.children, e, l ? "offsetWidth" : "offsetHeight", r);
      let h = m.parentElement;
      for (; !h.dataset.virtuosoScroller; )
        h = h.parentElement;
      const I = h.lastElementChild.dataset.viewportType === "window";
      let C;
      I && (C = h.ownerDocument.defaultView);
      const v = i ? l ? i.scrollLeft : i.scrollTop : I ? l ? C.scrollX || C.document.documentElement.scrollLeft : C.scrollY || C.document.documentElement.scrollTop : l ? h.scrollLeft : h.scrollTop, g = i ? l ? i.scrollWidth : i.scrollHeight : I ? l ? C.document.documentElement.scrollWidth : C.document.documentElement.scrollHeight : l ? h.scrollWidth : h.scrollHeight, p = i ? l ? i.offsetWidth : i.offsetHeight : I ? l ? C.innerWidth : C.innerHeight : l ? h.offsetWidth : h.offsetHeight;
      o({
        scrollHeight: g,
        scrollTop: Math.max(v, 0),
        viewportHeight: p
      }), s == null || s(
        l ? fn("column-gap", getComputedStyle(m).columnGap, r) : fn("row-gap", getComputedStyle(m).rowGap, r)
      ), x !== null && t(x);
    },
    [t, e, r, s, i, o, l]
  );
  return _e(a, n, c);
}
function wo(t, e, n, o) {
  const r = t.length;
  if (r === 0)
    return null;
  const s = [];
  for (let i = 0; i < r; i++) {
    const l = t.item(i);
    if (l.dataset.index === void 0)
      continue;
    const c = parseInt(l.dataset.index), a = parseFloat(l.dataset.knownSize), m = e(l, n);
    if (m === 0 && o("Zero-sized element, this should not happen", { child: l }, mt.ERROR), m === a)
      continue;
    const x = s[s.length - 1];
    s.length === 0 || x.size !== m || x.endIndex !== c - 1 ? s.push({ endIndex: c, size: m, startIndex: c }) : s[s.length - 1].endIndex++;
  }
  return s;
}
function fn(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n(`${t} was not resolved to pixel value correctly`, e, mt.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
function Ne(t, e, n) {
  const o = H.useRef(null), r = H.useCallback(
    (c) => {
      if (!(c != null && c.offsetParent))
        return;
      const a = c.getBoundingClientRect(), m = a.width;
      let x, h;
      if (e) {
        const I = e.getBoundingClientRect(), C = a.top - I.top;
        h = I.height - Math.max(0, C), x = C + e.scrollTop;
      } else {
        const I = i.current.ownerDocument.defaultView;
        h = I.innerHeight - Math.max(0, a.top), x = a.top + I.scrollY;
      }
      o.current = {
        offsetTop: x,
        visibleHeight: h,
        visibleWidth: m
      }, t(o.current);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t, e]
  ), { callbackRef: s, ref: i } = _e(r, !0, n), l = H.useCallback(() => {
    r(i.current);
  }, [r, i]);
  return H.useEffect(() => {
    var c;
    if (e) {
      e.addEventListener("scroll", l);
      const a = new ResizeObserver(() => {
        requestAnimationFrame(l);
      });
      return a.observe(e), () => {
        e.removeEventListener("scroll", l), a.unobserve(e);
      };
    } else {
      const a = (c = i.current) == null ? void 0 : c.ownerDocument.defaultView;
      return a == null || a.addEventListener("scroll", l), a == null || a.addEventListener("resize", l), () => {
        a == null || a.removeEventListener("scroll", l), a == null || a.removeEventListener("resize", l);
      };
    }
  }, [l, e, i]), s;
}
const at = U(
  () => {
    const t = $(), e = $(), n = w(0), o = $(), r = w(0), s = $(), i = $(), l = w(0), c = w(0), a = w(0), m = w(0), x = $(), h = $(), I = w(!1), C = w(!1), v = w(!1);
    return O(
      S(
        t,
        E(({ scrollTop: g }) => g)
      ),
      e
    ), O(
      S(
        t,
        E(({ scrollHeight: g }) => g)
      ),
      i
    ), O(e, r), {
      deviation: n,
      fixedFooterHeight: a,
      fixedHeaderHeight: c,
      footerHeight: m,
      headerHeight: l,
      horizontalDirection: C,
      scrollBy: h,
      // input
      scrollContainerState: t,
      scrollHeight: i,
      scrollingInProgress: I,
      // signals
      scrollTo: x,
      scrollTop: e,
      skipAnimationFrameInResizeObserver: v,
      smoothScrollTargetReached: o,
      // state
      statefulScrollTop: r,
      viewportHeight: s
    };
  },
  [],
  { singleton: !0 }
), oe = { lvl: 0 };
function Ln(t, e) {
  const n = t.length;
  if (n === 0)
    return [];
  let { index: o, value: r } = e(t[0]);
  const s = [];
  for (let i = 1; i < n; i++) {
    const { index: l, value: c } = e(t[i]);
    s.push({ end: l - 1, start: o, value: r }), o = l, r = c;
  }
  return s.push({ end: 1 / 0, start: o, value: r }), s;
}
function j(t) {
  return t === oe;
}
function re(t, e) {
  if (!j(t))
    return e === t.k ? t.v : e < t.k ? re(t.l, e) : re(t.r, e);
}
function wt(t, e, n = "k") {
  if (j(t))
    return [-1 / 0, void 0];
  if (Number(t[n]) === e)
    return [t.k, t.v];
  if (Number(t[n]) < e) {
    const o = wt(t.r, e, n);
    return o[0] === -1 / 0 ? [t.k, t.v] : o;
  }
  return wt(t.l, e, n);
}
function pt(t, e, n) {
  return j(t) ? Pn(e, n, 1) : e === t.k ? st(t, { k: e, v: n }) : e < t.k ? mn(st(t, { l: pt(t.l, e, n) })) : mn(st(t, { r: pt(t.r, e, n) }));
}
function jt() {
  return oe;
}
function ye(t, e, n) {
  if (j(t))
    return [];
  const o = wt(t, e)[0];
  return vo(Ve(t, o, n));
}
function ze(t, e) {
  if (j(t)) return oe;
  const { k: n, l: o, r } = t;
  if (e === n) {
    if (j(o))
      return r;
    if (j(r))
      return o;
    {
      const [s, i] = Vn(o);
      return ge(st(t, { k: s, l: zn(o), v: i }));
    }
  } else return e < n ? ge(st(t, { l: ze(o, e) })) : ge(st(t, { r: ze(r, e) }));
}
function Gt(t) {
  return j(t) ? [] : [...Gt(t.l), { k: t.k, v: t.v }, ...Gt(t.r)];
}
function Ve(t, e, n) {
  if (j(t))
    return [];
  const { k: o, l: r, r: s, v: i } = t;
  let l = [];
  return o > e && (l = l.concat(Ve(r, e, n))), o >= e && o <= n && l.push({ k: o, v: i }), o <= n && (l = l.concat(Ve(s, e, n))), l;
}
function ge(t) {
  const { l: e, lvl: n, r: o } = t;
  if (o.lvl >= n - 1 && e.lvl >= n - 1)
    return t;
  if (n > o.lvl + 1) {
    if (Ee(e))
      return An(st(t, { lvl: n - 1 }));
    if (!j(e) && !j(e.r))
      return st(e.r, {
        l: st(e, { r: e.r.l }),
        lvl: n,
        r: st(t, {
          l: e.r.r,
          lvl: n - 1
        })
      });
    throw new Error("Unexpected empty nodes");
  } else {
    if (Ee(t))
      return Pe(st(t, { lvl: n - 1 }));
    if (!j(o) && !j(o.l)) {
      const r = o.l, s = Ee(r) ? o.lvl - 1 : o.lvl;
      return st(r, {
        l: st(t, {
          lvl: n - 1,
          r: r.l
        }),
        lvl: r.lvl + 1,
        r: Pe(st(o, { l: r.r, lvl: s }))
      });
    } else
      throw new Error("Unexpected empty nodes");
  }
}
function st(t, e) {
  return Pn(
    e.k !== void 0 ? e.k : t.k,
    e.v !== void 0 ? e.v : t.v,
    e.lvl !== void 0 ? e.lvl : t.lvl,
    e.l !== void 0 ? e.l : t.l,
    e.r !== void 0 ? e.r : t.r
  );
}
function zn(t) {
  return j(t.r) ? t.l : ge(st(t, { r: zn(t.r) }));
}
function Ee(t) {
  return j(t) || t.lvl > t.r.lvl;
}
function Vn(t) {
  return j(t.r) ? [t.k, t.v] : Vn(t.r);
}
function Pn(t, e, n, o = oe, r = oe) {
  return { k: t, l: o, lvl: n, r, v: e };
}
function mn(t) {
  return Pe(An(t));
}
function An(t) {
  const { l: e } = t;
  return !j(e) && e.lvl === t.lvl ? st(e, { r: st(t, { l: e.r }) }) : t;
}
function Pe(t) {
  const { lvl: e, r: n } = t;
  return !j(n) && !j(n.r) && n.lvl === e && n.r.lvl === e ? st(n, { l: st(t, { r: n.l }), lvl: e + 1 }) : t;
}
function vo(t) {
  return Ln(t, ({ k: e, v: n }) => ({ index: e, value: n }));
}
function Mn(t, e) {
  return !!(t && t.startIndex === e.startIndex && t.endIndex === e.endIndex);
}
function se(t, e) {
  return !!(t && t[0] === e[0] && t[1] === e[1]);
}
const De = U(
  () => ({ recalcInProgress: w(!1) }),
  [],
  { singleton: !0 }
);
function Wn(t, e, n) {
  return t[Se(t, e, n)];
}
function Se(t, e, n, o = 0) {
  let r = t.length - 1;
  for (; o <= r; ) {
    const s = Math.floor((o + r) / 2), i = t[s], l = n(i, e);
    if (l === 0)
      return s;
    if (l === -1) {
      if (r - o < 2)
        return s - 1;
      r = s - 1;
    } else {
      if (r === o)
        return s;
      o = s + 1;
    }
  }
  throw new Error(`Failed binary finding record in array - ${t.join(",")}, searched for ${e}`);
}
function yo(t, e, n, o) {
  const r = Se(t, e, o), s = Se(t, n, o, r);
  return t.slice(r, s + 1);
}
function vt(t, e) {
  return Math.round(t.getBoundingClientRect()[e]);
}
function Re(t) {
  return !j(t.groupOffsetTree);
}
function $e({ index: t }, e) {
  return e === t ? 0 : e < t ? -1 : 1;
}
function Ro() {
  return {
    groupIndices: [],
    groupOffsetTree: jt(),
    lastIndex: 0,
    lastOffset: 0,
    lastSize: 0,
    offsetTree: [],
    sizeTree: jt()
  };
}
function bo(t, e) {
  let n = j(t) ? 0 : 1 / 0;
  for (const o of e) {
    const { endIndex: r, size: s, startIndex: i } = o;
    if (n = Math.min(n, i), j(t)) {
      t = pt(t, 0, s);
      continue;
    }
    const l = ye(t, i - 1, r + 1);
    if (l.some(Lo(o)))
      continue;
    let c = !1, a = !1;
    for (const { end: m, start: x, value: h } of l)
      c ? (r >= x || s === h) && (t = ze(t, x)) : (a = h !== s, c = !0), m > r && r >= x && h !== s && (t = pt(t, r + 1, h));
    a && (t = pt(t, i, s));
  }
  return [t, n];
}
function Ho(t) {
  return typeof t.groupIndex < "u";
}
function Eo({ offset: t }, e) {
  return e === t ? 0 : e < t ? -1 : 1;
}
function ie(t, e, n) {
  if (e.length === 0)
    return 0;
  const { index: o, offset: r, size: s } = Wn(e, t, $e), i = t - o, l = s * i + (i - 1) * n + r;
  return l > 0 ? l + n : l;
}
function Gn(t, e) {
  if (!Re(e))
    return t;
  let n = 0;
  for (; e.groupIndices[n] <= t + n; )
    n++;
  return t + n;
}
function _n(t, e, n) {
  if (Ho(t))
    return e.groupIndices[t.groupIndex] + 1;
  {
    const o = t.index === "LAST" ? n : t.index;
    let r = Gn(o, e);
    return r = Math.max(0, r, Math.min(n, r)), r;
  }
}
function Bo(t, e, n, o = 0) {
  return o > 0 && (e = Math.max(e, Wn(t, o, $e).offset)), Ln(yo(t, e, n, Eo), Oo);
}
function ko(t, [e, n, o, r]) {
  e.length > 0 && o("received item sizes", e, mt.DEBUG);
  const s = t.sizeTree;
  let i = s, l = 0;
  if (n.length > 0 && j(s) && e.length === 2) {
    const h = e[0].size, I = e[1].size;
    i = n.reduce((C, v) => pt(pt(C, v, h), v + 1, I), i);
  } else
    [i, l] = bo(i, e);
  if (i === s)
    return t;
  const { lastIndex: c, lastOffset: a, lastSize: m, offsetTree: x } = Ae(t.offsetTree, l, i, r);
  return {
    groupIndices: n,
    groupOffsetTree: n.reduce((h, I) => pt(h, I, ie(I, x, r)), jt()),
    lastIndex: c,
    lastOffset: a,
    lastSize: m,
    offsetTree: x,
    sizeTree: i
  };
}
function Fo(t) {
  return Gt(t).map(({ k: e, v: n }, o, r) => {
    const s = r[o + 1];
    return { endIndex: s ? s.k - 1 : 1 / 0, size: n, startIndex: e };
  });
}
function pn(t, e) {
  let n = 0, o = 0;
  for (; n < t; )
    n += e[o + 1] - e[o] - 1, o++;
  return o - (n === t ? 0 : 1);
}
function Ae(t, e, n, o) {
  let r = t, s = 0, i = 0, l = 0, c = 0;
  if (e !== 0) {
    c = Se(r, e - 1, $e), l = r[c].offset;
    const m = wt(n, e - 1);
    s = m[0], i = m[1], r.length && r[c].size === wt(n, e)[1] && (c -= 1), r = r.slice(0, c + 1);
  } else
    r = [];
  for (const { start: a, value: m } of ye(n, e, 1 / 0)) {
    const x = a - s, h = x * i + l + x * o;
    r.push({
      index: a,
      offset: h,
      size: m
    }), s = a, l = h, i = m;
  }
  return {
    lastIndex: s,
    lastOffset: l,
    lastSize: i,
    offsetTree: r
  };
}
function Oo(t) {
  return { index: t.index, value: t };
}
function Lo(t) {
  const { endIndex: e, size: n, startIndex: o } = t;
  return (r) => r.start === o && (r.end === e || r.end === 1 / 0) && r.value === n;
}
const zo = {
  offsetHeight: "height",
  offsetWidth: "width"
}, Et = U(
  ([{ log: t }, { recalcInProgress: e }]) => {
    const n = $(), o = $(), r = ct(o, 0), s = $(), i = $(), l = w(0), c = w([]), a = w(void 0), m = w(void 0), x = w((f, d) => vt(f, zo[d])), h = w(void 0), I = w(0), C = Ro(), v = ct(
      S(n, N(c, t, I), bt(ko, C), Y()),
      C
    ), g = ct(
      S(
        c,
        Y(),
        bt((f, d) => ({ current: d, prev: f.current }), {
          current: [],
          prev: []
        }),
        E(({ prev: f }) => f)
      ),
      []
    );
    O(
      S(
        c,
        A((f) => f.length > 0),
        N(v, I),
        E(([f, d, y]) => {
          const B = f.reduce((k, L, z) => pt(k, L, ie(L, d.offsetTree, y) || z), jt());
          return {
            ...d,
            groupIndices: f,
            groupOffsetTree: B
          };
        })
      ),
      v
    ), O(
      S(
        o,
        N(v),
        A(([f, { lastIndex: d }]) => f < d),
        E(([f, { lastIndex: d, lastSize: y }]) => [
          {
            endIndex: d,
            size: y,
            startIndex: f
          }
        ])
      ),
      n
    ), O(a, m);
    const p = ct(
      S(
        a,
        E((f) => f === void 0)
      ),
      !0
    );
    O(
      S(
        m,
        A((f) => f !== void 0 && j(ot(v).sizeTree)),
        E((f) => [{ endIndex: 0, size: f, startIndex: 0 }])
      ),
      n
    );
    const u = ht(
      S(
        n,
        N(v),
        bt(
          ({ sizes: f }, [d, y]) => ({
            changed: y !== f,
            sizes: y
          }),
          { changed: !1, sizes: C }
        ),
        E((f) => f.changed)
      )
    );
    K(
      S(
        l,
        bt(
          (f, d) => ({ diff: f.prev - d, prev: d }),
          { diff: 0, prev: 0 }
        ),
        E((f) => f.diff)
      ),
      (f) => {
        const { groupIndices: d } = ot(v);
        if (f > 0)
          G(e, !0), G(s, f + pn(f, d));
        else if (f < 0) {
          const y = ot(g);
          y.length > 0 && (f -= pn(-f, y)), G(i, f);
        }
      }
    ), K(S(l, N(t)), ([f, d]) => {
      f < 0 && d(
        "`firstItemIndex` prop should not be set to less than zero. If you don't know the total count, just use a very high value",
        { firstItemIndex: l },
        mt.ERROR
      );
    });
    const T = ht(s);
    O(
      S(
        s,
        N(v),
        E(([f, d]) => {
          const y = d.groupIndices.length > 0, B = [], k = d.lastSize;
          if (y) {
            const L = re(d.sizeTree, 0);
            let z = 0, _ = 0;
            for (; z < f; ) {
              const F = d.groupIndices[_], q = d.groupIndices.length === _ + 1 ? 1 / 0 : d.groupIndices[_ + 1] - F - 1;
              B.push({
                endIndex: F,
                size: L,
                startIndex: F
              }), B.push({
                endIndex: F + 1 + q - 1,
                size: k,
                startIndex: F + 1
              }), _++, z += q + 1;
            }
            const J = Gt(d.sizeTree);
            return z !== f && J.shift(), J.reduce(
              (F, { k: q, v: it }) => {
                let dt = F.ranges;
                return F.prevSize !== 0 && (dt = [
                  ...F.ranges,
                  {
                    endIndex: q + f - 1,
                    size: F.prevSize,
                    startIndex: F.prevIndex
                  }
                ]), {
                  prevIndex: q + f,
                  prevSize: it,
                  ranges: dt
                };
              },
              {
                prevIndex: f,
                prevSize: 0,
                ranges: B
              }
            ).ranges;
          }
          return Gt(d.sizeTree).reduce(
            (L, { k: z, v: _ }) => ({
              prevIndex: z + f,
              prevSize: _,
              ranges: [...L.ranges, { endIndex: z + f - 1, size: L.prevSize, startIndex: L.prevIndex }]
            }),
            {
              prevIndex: 0,
              prevSize: k,
              ranges: []
            }
          ).ranges;
        })
      ),
      n
    );
    const b = ht(
      S(
        i,
        N(v, I),
        E(([f, { offsetTree: d }, y]) => {
          const B = -f;
          return ie(B, d, y);
        })
      )
    );
    return O(
      S(
        i,
        N(v, I),
        E(([f, d, y]) => {
          if (d.groupIndices.length > 0) {
            if (j(d.sizeTree))
              return d;
            let k = jt();
            const L = ot(g);
            let z = 0, _ = 0, J = 0;
            for (; z < -f; ) {
              J = L[_];
              const F = L[_ + 1] - J - 1;
              _++, z += F + 1;
            }
            if (k = Gt(d.sizeTree).reduce((F, { k: q, v: it }) => pt(F, Math.max(0, q + f), it), k), z !== -f) {
              const F = re(d.sizeTree, J);
              k = pt(k, 0, F);
              const q = wt(d.sizeTree, -f + 1)[1];
              k = pt(k, 1, q);
            }
            return {
              ...d,
              sizeTree: k,
              ...Ae(d.offsetTree, 0, k, y)
            };
          } else {
            const k = Gt(d.sizeTree).reduce((L, { k: z, v: _ }) => pt(L, Math.max(0, z + f), _), jt());
            return {
              ...d,
              sizeTree: k,
              ...Ae(d.offsetTree, 0, k, y)
            };
          }
        })
      ),
      v
    ), {
      beforeUnshiftWith: T,
      // input
      data: h,
      defaultItemSize: m,
      firstItemIndex: l,
      fixedItemSize: a,
      gap: I,
      groupIndices: c,
      itemSize: x,
      listRefresh: u,
      shiftWith: i,
      shiftWithOffset: b,
      sizeRanges: n,
      // output
      sizes: v,
      statefulTotalCount: r,
      totalCount: o,
      trackItemSizes: p,
      unshiftWith: s
    };
  },
  X(Vt, De),
  { singleton: !0 }
);
function Vo(t) {
  return t.reduce(
    (e, n) => (e.groupIndices.push(e.totalCount), e.totalCount += n + 1, e),
    {
      groupIndices: [],
      totalCount: 0
    }
  );
}
const Nn = U(
  ([{ groupIndices: t, sizes: e, totalCount: n }, { headerHeight: o, scrollTop: r }]) => {
    const s = $(), i = $(), l = ht(S(s, E(Vo)));
    return O(
      S(
        l,
        E((c) => c.totalCount)
      ),
      n
    ), O(
      S(
        l,
        E((c) => c.groupIndices)
      ),
      t
    ), O(
      S(
        rt(r, e, o),
        A(([c, a]) => Re(a)),
        E(([c, a, m]) => wt(a.groupOffsetTree, Math.max(c - m, 0), "v")[0]),
        Y(),
        E((c) => [c])
      ),
      i
    ), { groupCounts: s, topItemsIndexes: i };
  },
  X(Et, at)
), Pt = U(
  ([{ log: t }]) => {
    const e = w(!1), n = ht(
      S(
        e,
        A((o) => o),
        Y()
      )
    );
    return K(e, (o) => {
      o && ot(t)("props updated", {}, mt.DEBUG);
    }), { didMount: n, propsReady: e };
  },
  X(Vt),
  { singleton: !0 }
), Po = typeof document < "u" && "scrollBehavior" in document.documentElement.style;
function Dn(t) {
  const e = typeof t == "number" ? { index: t } : t;
  return e.align || (e.align = "start"), (!e.behavior || !Po) && (e.behavior = "auto"), e.offset || (e.offset = 0), e;
}
const ce = U(
  ([
    { gap: t, listRefresh: e, sizes: n, totalCount: o },
    {
      fixedFooterHeight: r,
      fixedHeaderHeight: s,
      footerHeight: i,
      headerHeight: l,
      scrollingInProgress: c,
      scrollTo: a,
      smoothScrollTargetReached: m,
      viewportHeight: x
    },
    { log: h }
  ]) => {
    const I = $(), C = $(), v = w(0);
    let g = null, p = null, u = null;
    function T() {
      g && (g(), g = null), u && (u(), u = null), p && (clearTimeout(p), p = null), G(c, !1);
    }
    return O(
      S(
        I,
        N(n, x, o, v, l, i, h),
        N(t, s, r),
        E(
          ([
            [b, f, d, y, B, k, L, z],
            _,
            J,
            nt
          ]) => {
            const F = Dn(b), { align: q, behavior: it, offset: dt } = F, St = y - 1, ft = _n(F, f, St);
            let ut = ie(ft, f.offsetTree, _) + k;
            q === "end" ? (ut += J + wt(f.sizeTree, ft)[1] - d + nt, ft === St && (ut += L)) : q === "center" ? ut += (J + wt(f.sizeTree, ft)[1] - d + nt) / 2 : ut -= B, dt && (ut += dt);
            const At = (xt) => {
              T(), xt ? (z("retrying to scroll to", { location: b }, mt.DEBUG), G(I, b)) : (G(C, !0), z("list did not change, scroll successful", {}, mt.DEBUG));
            };
            if (T(), it === "smooth") {
              let xt = !1;
              u = K(e, (Xt) => {
                xt = xt || Xt;
              }), g = Tt(m, () => {
                At(xt);
              });
            } else
              g = Tt(S(e, Ao(150)), At);
            return p = setTimeout(() => {
              T();
            }, 1200), G(c, !0), z("scrolling from index to", { behavior: it, index: ft, top: ut }, mt.DEBUG), { behavior: it, top: ut };
          }
        )
      ),
      a
    ), {
      scrollTargetReached: C,
      scrollToIndex: I,
      topListHeight: v
    };
  },
  X(Et, at, Vt),
  { singleton: !0 }
);
function Ao(t) {
  return (e) => {
    const n = setTimeout(() => {
      e(!1);
    }, t);
    return (o) => {
      o && (e(!0), clearTimeout(n));
    };
  };
}
function Ue(t, e) {
  t == 0 ? e() : requestAnimationFrame(() => {
    Ue(t - 1, e);
  });
}
function Ke(t, e) {
  const n = e - 1;
  return typeof t == "number" ? t : t.index === "LAST" ? n : t.index;
}
const ue = U(
  ([{ defaultItemSize: t, listRefresh: e, sizes: n }, { scrollTop: o }, { scrollTargetReached: r, scrollToIndex: s }, { didMount: i }]) => {
    const l = w(!0), c = w(0), a = w(!0);
    return O(
      S(
        i,
        N(c),
        A(([m, x]) => !!x),
        Rt(!1)
      ),
      l
    ), O(
      S(
        i,
        N(c),
        A(([m, x]) => !!x),
        Rt(!1)
      ),
      a
    ), K(
      S(
        rt(e, i),
        N(l, n, t, a),
        A(([[, m], x, { sizeTree: h }, I, C]) => m && (!j(h) || We(I)) && !x && !C),
        N(c)
      ),
      ([, m]) => {
        Tt(r, () => {
          G(a, !0);
        }), Ue(4, () => {
          Tt(o, () => {
            G(l, !0);
          }), G(s, m);
        });
      }
    ), {
      initialItemFinalLocationReached: a,
      initialTopMostItemIndex: c,
      scrolledToInitialItem: l
    };
  },
  X(Et, at, ce, Pt),
  { singleton: !0 }
);
function $n(t, e) {
  return Math.abs(t - e) < 1.01;
}
const le = "up", te = "down", Mo = "none", Wo = {
  atBottom: !1,
  notAtBottomBecause: "NOT_SHOWING_LAST_ITEM",
  state: {
    offsetBottom: 0,
    scrollHeight: 0,
    scrollTop: 0,
    viewportHeight: 0
  }
}, Go = 0, ae = U(([{ footerHeight: t, headerHeight: e, scrollBy: n, scrollContainerState: o, scrollTop: r, viewportHeight: s }]) => {
  const i = w(!1), l = w(!0), c = $(), a = $(), m = w(4), x = w(Go), h = ct(
    S(
      Le(S(V(r), Dt(1), Rt(!0)), S(V(r), Dt(1), Rt(!1), dn(100))),
      Y()
    ),
    !1
  ), I = ct(
    S(Le(S(n, Rt(!0)), S(n, Rt(!1), dn(200))), Y()),
    !1
  );
  O(
    S(
      rt(V(r), V(x)),
      E(([u, T]) => u <= T),
      Y()
    ),
    l
  ), O(S(l, kt(50)), a);
  const C = ht(
    S(
      rt(o, V(s), V(e), V(t), V(m)),
      bt((u, [{ scrollHeight: T, scrollTop: b }, f, d, y, B]) => {
        const k = b + f - T > -B, L = {
          scrollHeight: T,
          scrollTop: b,
          viewportHeight: f
        };
        if (k) {
          let _, J;
          return b > u.state.scrollTop ? (_ = "SCROLLED_DOWN", J = u.state.scrollTop - b) : (_ = "SIZE_DECREASED", J = u.state.scrollTop - b || u.scrollTopDelta), {
            atBottom: !0,
            atBottomBecause: _,
            scrollTopDelta: J,
            state: L
          };
        }
        let z;
        return L.scrollHeight > u.state.scrollHeight ? z = "SIZE_INCREASED" : f < u.state.viewportHeight ? z = "VIEWPORT_HEIGHT_DECREASING" : b < u.state.scrollTop ? z = "SCROLLING_UPWARDS" : z = "NOT_FULLY_SCROLLED_TO_LAST_ITEM_BOTTOM", {
          atBottom: !1,
          notAtBottomBecause: z,
          state: L
        };
      }, Wo),
      Y((u, T) => u && u.atBottom === T.atBottom)
    )
  ), v = ct(
    S(
      o,
      bt(
        (u, { scrollHeight: T, scrollTop: b, viewportHeight: f }) => {
          if ($n(u.scrollHeight, T))
            return {
              changed: !1,
              jump: 0,
              scrollHeight: T,
              scrollTop: b
            };
          {
            const d = T - (b + f) < 1;
            return u.scrollTop !== b && d ? {
              changed: !0,
              jump: u.scrollTop - b,
              scrollHeight: T,
              scrollTop: b
            } : {
              changed: !0,
              jump: 0,
              scrollHeight: T,
              scrollTop: b
            };
          }
        },
        { changed: !1, jump: 0, scrollHeight: 0, scrollTop: 0 }
      ),
      A((u) => u.changed),
      E((u) => u.jump)
    ),
    0
  );
  O(
    S(
      C,
      E((u) => u.atBottom)
    ),
    i
  ), O(S(i, kt(50)), c);
  const g = w(te);
  O(
    S(
      o,
      E(({ scrollTop: u }) => u),
      Y(),
      bt(
        (u, T) => ot(I) ? { direction: u.direction, prevScrollTop: T } : { direction: T < u.prevScrollTop ? le : te, prevScrollTop: T },
        { direction: te, prevScrollTop: 0 }
      ),
      E((u) => u.direction)
    ),
    g
  ), O(S(o, kt(50), Rt(Mo)), g);
  const p = w(0);
  return O(
    S(
      h,
      A((u) => !u),
      Rt(0)
    ),
    p
  ), O(
    S(
      r,
      kt(100),
      N(h),
      A(([u, T]) => !!T),
      bt(([u, T], [b]) => [T, b], [0, 0]),
      E(([u, T]) => T - u)
    ),
    p
  ), {
    atBottomState: C,
    atBottomStateChange: c,
    atBottomThreshold: m,
    atTopStateChange: a,
    atTopThreshold: x,
    isAtBottom: i,
    isAtTop: l,
    isScrolling: h,
    lastJumpDueToItemResize: v,
    scrollDirection: g,
    scrollVelocity: p
  };
}, X(at)), xe = "top", Te = "bottom", hn = "none";
function gn(t, e, n) {
  return typeof t == "number" ? n === le && e === xe || n === te && e === Te ? t : 0 : n === le ? e === xe ? t.main : t.reverse : e === Te ? t.main : t.reverse;
}
function In(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) != null ? n : 0;
}
const je = U(
  ([{ deviation: t, fixedHeaderHeight: e, headerHeight: n, scrollTop: o, viewportHeight: r }]) => {
    const s = $(), i = w(0), l = w(0), c = w(0), a = ct(
      S(
        rt(
          V(o),
          V(r),
          V(n),
          V(s, se),
          V(c),
          V(i),
          V(e),
          V(t),
          V(l)
        ),
        E(
          ([
            m,
            x,
            h,
            [I, C],
            v,
            g,
            p,
            u,
            T
          ]) => {
            const b = m - u, f = g + p, d = Math.max(h - b, 0);
            let y = hn;
            const B = In(T, xe), k = In(T, Te);
            return I -= u, I += h + p, C += h + p, C -= u, I > m + f - B && (y = le), C < m - d + x + k && (y = te), y !== hn ? [
              Math.max(b - h - gn(v, xe, y) - B, 0),
              b - d - p + x + gn(v, Te, y) + k
            ] : null;
          }
        ),
        A((m) => m != null),
        Y(se)
      ),
      [0, 0]
    );
    return {
      increaseViewportBy: l,
      // input
      listBoundary: s,
      overscan: c,
      topListHeight: i,
      // output
      visibleRange: a
    };
  },
  X(at),
  { singleton: !0 }
);
function _o(t, e, n) {
  if (Re(e)) {
    const o = Gn(t, e);
    return [
      { index: wt(e.groupOffsetTree, o)[0], offset: 0, size: 0 },
      { data: n == null ? void 0 : n[0], index: o, offset: 0, size: 0 }
    ];
  }
  return [{ data: n == null ? void 0 : n[0], index: t, offset: 0, size: 0 }];
}
const Be = {
  bottom: 0,
  firstItemIndex: 0,
  items: [],
  offsetBottom: 0,
  offsetTop: 0,
  top: 0,
  topItems: [],
  topListHeight: 0,
  totalCount: 0
};
function Ie(t, e, n, o, r, s) {
  const { lastIndex: i, lastOffset: l, lastSize: c } = r;
  let a = 0, m = 0;
  if (t.length > 0) {
    a = t[0].offset;
    const v = t[t.length - 1];
    m = v.offset + v.size;
  }
  const x = n - i, h = l + x * c + (x - 1) * o, I = a, C = h - m;
  return {
    bottom: m,
    firstItemIndex: s,
    items: Sn(t, r, s),
    offsetBottom: C,
    offsetTop: a,
    top: I,
    topItems: Sn(e, r, s),
    topListHeight: e.reduce((v, g) => g.size + v, 0),
    totalCount: n
  };
}
function Un(t, e, n, o, r, s) {
  let i = 0;
  if (n.groupIndices.length > 0)
    for (const m of n.groupIndices) {
      if (m - i >= t)
        break;
      i++;
    }
  const l = t + i, c = Ke(e, l), a = Array.from({ length: l }).map((m, x) => ({
    data: s[x + c],
    index: x + c,
    offset: 0,
    size: 0
  }));
  return Ie(a, [], l, r, n, o);
}
function Sn(t, e, n) {
  if (t.length === 0)
    return [];
  if (!Re(e))
    return t.map((a) => ({ ...a, index: a.index + n, originalIndex: a.index }));
  const o = t[0].index, r = t[t.length - 1].index, s = [], i = ye(e.groupOffsetTree, o, r);
  let l, c = 0;
  for (const a of t) {
    (!l || l.end < a.index) && (l = i.shift(), c = e.groupIndices.indexOf(l.start));
    let m;
    a.index === l.start ? m = {
      index: c,
      type: "group"
    } : m = {
      groupIndex: c,
      index: a.index - (c + 1) + n
    }, s.push({
      ...m,
      data: a.data,
      offset: a.offset,
      originalIndex: a.index,
      size: a.size
    });
  }
  return s;
}
const $t = U(
  ([
    { data: t, firstItemIndex: e, gap: n, sizes: o, totalCount: r },
    s,
    { listBoundary: i, topListHeight: l, visibleRange: c },
    { initialTopMostItemIndex: a, scrolledToInitialItem: m },
    { topListHeight: x },
    h,
    { didMount: I },
    { recalcInProgress: C }
  ]) => {
    const v = w([]), g = w(0), p = $();
    O(s.topItemsIndexes, v);
    const u = ct(
      S(
        rt(
          I,
          C,
          V(c, se),
          V(r),
          V(o),
          V(a),
          m,
          V(v),
          V(e),
          V(n),
          t
        ),
        A(([d, y, , B, , , , , , , k]) => {
          const L = k && k.length !== B;
          return d && !y && !L;
        }),
        E(
          ([
            ,
            ,
            [d, y],
            B,
            k,
            L,
            z,
            _,
            J,
            nt,
            F
          ]) => {
            const q = k, { offsetTree: it, sizeTree: dt } = q, St = ot(g);
            if (B === 0)
              return { ...Be, totalCount: B };
            if (d === 0 && y === 0)
              return St === 0 ? { ...Be, totalCount: B } : Un(St, L, k, J, nt, F || []);
            if (j(dt))
              return St > 0 ? null : Ie(
                _o(Ke(L, B), q, F),
                [],
                B,
                nt,
                q,
                J
              );
            const ft = [];
            if (_.length > 0) {
              const Mt = _[0], yt = _[_.length - 1];
              let Bt = 0;
              for (const R of ye(dt, Mt, yt)) {
                const D = R.value, Q = Math.max(R.start, Mt), lt = Math.min(R.end, yt);
                for (let tt = Q; tt <= lt; tt++)
                  ft.push({ data: F == null ? void 0 : F[tt], index: tt, offset: Bt, size: D }), Bt += D;
              }
            }
            if (!z)
              return Ie([], ft, B, nt, q, J);
            const ut = _.length > 0 ? _[_.length - 1] + 1 : 0, At = Bo(it, d, y, ut);
            if (At.length === 0)
              return null;
            const xt = B - 1, Xt = ve([], (Mt) => {
              for (const yt of At) {
                const Bt = yt.value;
                let R = Bt.offset, D = yt.start;
                const Q = Bt.size;
                if (Bt.offset < d) {
                  D += Math.floor((d - Bt.offset + nt) / (Q + nt));
                  const tt = D - yt.start;
                  R += tt * Q + tt * nt;
                }
                D < ut && (R += (ut - D) * Q, D = ut);
                const lt = Math.min(yt.end, xt);
                for (let tt = D; tt <= lt && !(R >= y); tt++)
                  Mt.push({ data: F == null ? void 0 : F[tt], index: tt, offset: R, size: Q }), R += Q + nt;
              }
            });
            return Ie(Xt, ft, B, nt, q, J);
          }
        ),
        //@ts-expect-error filter needs to be fixed
        A((d) => d !== null),
        Y()
      ),
      Be
    );
    O(
      S(
        t,
        A(We),
        E((d) => d == null ? void 0 : d.length)
      ),
      r
    ), O(
      S(
        u,
        E((d) => d.topListHeight)
      ),
      x
    ), O(x, l), O(
      S(
        u,
        E((d) => [d.top, d.bottom])
      ),
      i
    ), O(
      S(
        u,
        E((d) => d.items)
      ),
      p
    );
    const T = ht(
      S(
        u,
        A(({ items: d }) => d.length > 0),
        N(r, t),
        A(([{ items: d }, y]) => d[d.length - 1].originalIndex === y - 1),
        E(([, d, y]) => [d - 1, y]),
        Y(se),
        E(([d]) => d)
      )
    ), b = ht(
      S(
        u,
        kt(200),
        A(({ items: d, topItems: y }) => d.length > 0 && d[0].originalIndex === y.length),
        E(({ items: d }) => d[0].index),
        Y()
      )
    ), f = ht(
      S(
        u,
        A(({ items: d }) => d.length > 0),
        E(({ items: d }) => {
          let y = 0, B = d.length - 1;
          for (; d[y].type === "group" && y < B; )
            y++;
          for (; d[B].type === "group" && B > y; )
            B--;
          return {
            endIndex: d[B].index,
            startIndex: d[y].index
          };
        }),
        Y(Mn)
      )
    );
    return { endReached: T, initialItemCount: g, itemsRendered: p, listState: u, rangeChanged: f, startReached: b, topItemsIndexes: v, ...h };
  },
  X(
    Et,
    Nn,
    je,
    ue,
    ce,
    ae,
    Pt,
    De
  ),
  { singleton: !0 }
), Kn = U(
  ([{ fixedFooterHeight: t, fixedHeaderHeight: e, footerHeight: n, headerHeight: o }, { listState: r }]) => {
    const s = $(), i = ct(
      S(
        rt(n, t, o, e, r),
        E(([l, c, a, m, x]) => l + c + a + m + x.offsetBottom + x.bottom)
      ),
      0
    );
    return O(V(i), s), { totalListHeight: i, totalListHeightChanged: s };
  },
  X(at, $t),
  { singleton: !0 }
), No = U(
  ([{ viewportHeight: t }, { totalListHeight: e }]) => {
    const n = w(!1), o = ct(
      S(
        rt(n, t, e),
        A(([r]) => r),
        E(([, r, s]) => Math.max(0, r - s)),
        kt(0),
        Y()
      ),
      0
    );
    return { alignToBottom: n, paddingTopAddition: o };
  },
  X(at, Kn),
  { singleton: !0 }
), jn = U(() => ({
  context: w(null)
})), Do = ({
  itemBottom: t,
  itemTop: e,
  locationParams: { align: n, behavior: o, ...r },
  viewportBottom: s,
  viewportTop: i
}) => e < i ? { ...r, align: n != null ? n : "start", behavior: o } : t > s ? { ...r, align: n != null ? n : "end", behavior: o } : null, qn = U(
  ([
    { gap: t, sizes: e, totalCount: n },
    { fixedFooterHeight: o, fixedHeaderHeight: r, headerHeight: s, scrollingInProgress: i, scrollTop: l, viewportHeight: c },
    { scrollToIndex: a }
  ]) => {
    const m = $();
    return O(
      S(
        m,
        N(e, c, n, s, r, o, l),
        N(t),
        E(([[x, h, I, C, v, g, p, u], T]) => {
          const { align: b, behavior: f, calculateViewLocation: d = Do, done: y, ...B } = x, k = _n(x, h, C - 1), L = ie(k, h.offsetTree, T) + v + g, z = L + wt(h.sizeTree, k)[1], _ = u + g, J = u + I - p, nt = d({
            itemBottom: z,
            itemTop: L,
            locationParams: { align: b, behavior: f, ...B },
            viewportBottom: J,
            viewportTop: _
          });
          return nt ? y && Tt(
            S(
              i,
              A((F) => !F),
              // skips the initial publish of false, and the cleanup call.
              // but if scrollingInProgress is true, we skip the initial publish.
              Dt(ot(i) ? 1 : 2)
            ),
            y
          ) : y && y(), nt;
        }),
        A((x) => x !== null)
      ),
      a
    ), {
      scrollIntoView: m
    };
  },
  X(Et, at, ce, $t, Vt),
  { singleton: !0 }
);
function xn(t) {
  return t ? t === "smooth" ? "smooth" : "auto" : !1;
}
const $o = (t, e) => typeof t == "function" ? xn(t(e)) : e && xn(t), Uo = U(
  ([
    { listRefresh: t, totalCount: e, fixedItemSize: n, data: o },
    { atBottomState: r, isAtBottom: s },
    { scrollToIndex: i },
    { scrolledToInitialItem: l },
    { didMount: c, propsReady: a },
    { log: m },
    { scrollingInProgress: x },
    { context: h },
    { scrollIntoView: I }
  ]) => {
    const C = w(!1), v = $();
    let g = null;
    function p(f) {
      G(i, {
        align: "end",
        behavior: f,
        index: "LAST"
      });
    }
    K(
      S(
        rt(S(V(e), Dt(1)), c),
        N(V(C), s, l, x),
        E(([[f, d], y, B, k, L]) => {
          let z = d && k, _ = "auto";
          return z && (_ = $o(y, B || L), z = z && !!_), { followOutputBehavior: _, shouldFollow: z, totalCount: f };
        }),
        A(({ shouldFollow: f }) => f)
      ),
      ({ followOutputBehavior: f, totalCount: d }) => {
        g && (g(), g = null), ot(n) ? requestAnimationFrame(() => {
          ot(m)("following output to ", { totalCount: d }, mt.DEBUG), p(f);
        }) : g = Tt(t, () => {
          ot(m)("following output to ", { totalCount: d }, mt.DEBUG), p(f), g = null;
        });
      }
    );
    function u(f) {
      const d = Tt(r, (y) => {
        f && !y.atBottom && y.notAtBottomBecause === "SIZE_INCREASED" && !g && (ot(m)("scrolling to bottom due to increased size", {}, mt.DEBUG), p("auto"));
      });
      setTimeout(d, 100);
    }
    K(
      S(
        rt(V(C), e, a),
        A(([f, , d]) => f && d),
        bt(
          ({ value: f }, [, d]) => ({ refreshed: f === d, value: d }),
          { refreshed: !1, value: 0 }
        ),
        A(({ refreshed: f }) => f),
        N(C, e)
      ),
      ([, f]) => {
        ot(l) && u(f !== !1);
      }
    ), K(v, () => {
      u(ot(C) !== !1);
    }), K(rt(V(C), r), ([f, d]) => {
      f && !d.atBottom && d.notAtBottomBecause === "VIEWPORT_HEIGHT_DECREASING" && p("auto");
    });
    const T = w(null), b = $();
    return O(
      Le(
        S(
          V(o),
          E((f) => {
            var d;
            return (d = f == null ? void 0 : f.length) != null ? d : 0;
          })
        ),
        S(V(e))
      ),
      b
    ), K(
      S(
        rt(S(b, Dt(1)), c),
        N(V(T), l, x, h),
        E(([[f, d], y, B, k, L]) => d && B && (y == null ? void 0 : y({ context: L, totalCount: f, scrollingInProgress: k }))),
        A((f) => !!f),
        kt(0)
      ),
      (f) => {
        g && (g(), g = null), ot(n) ? requestAnimationFrame(() => {
          ot(m)("scrolling into view", {}), G(I, f);
        }) : g = Tt(t, () => {
          ot(m)("scrolling into view", {}), G(I, f), g = null;
        });
      }
    ), { autoscrollToBottom: v, followOutput: C, scrollIntoViewOnChange: T };
  },
  X(
    Et,
    ae,
    ce,
    ue,
    Pt,
    Vt,
    at,
    jn,
    qn
  )
), Ko = U(
  ([{ data: t, firstItemIndex: e, gap: n, sizes: o }, { initialTopMostItemIndex: r }, { initialItemCount: s, listState: i }, { didMount: l }]) => (O(
    S(
      l,
      N(s),
      A(([, c]) => c !== 0),
      N(r, o, e, n, t),
      E(([[, c], a, m, x, h, I = []]) => Un(c, a, m, x, h, I))
    ),
    i
  ), {}),
  X(Et, ue, $t, Pt),
  { singleton: !0 }
), jo = U(
  ([{ didMount: t }, { scrollTo: e }, { listState: n }]) => {
    const o = w(0);
    return K(
      S(
        t,
        N(o),
        A(([, r]) => r !== 0),
        E(([, r]) => ({ top: r }))
      ),
      (r) => {
        Tt(
          S(
            n,
            Dt(1),
            A((s) => s.items.length > 1)
          ),
          () => {
            requestAnimationFrame(() => {
              G(e, r);
            });
          }
        );
      }
    ), {
      initialScrollTop: o
    };
  },
  X(Pt, at, $t),
  { singleton: !0 }
), Yn = U(
  ([{ scrollVelocity: t }]) => {
    const e = w(!1), n = $(), o = w(!1);
    return O(
      S(
        t,
        N(o, e, n),
        A(([r, s]) => !!s),
        E(([r, s, i, l]) => {
          const { enter: c, exit: a } = s;
          if (i) {
            if (a(r, l))
              return !1;
          } else if (c(r, l))
            return !0;
          return i;
        }),
        Y()
      ),
      e
    ), K(
      S(rt(e, t, n), N(o)),
      ([[r, s, i], l]) => {
        r && l && l.change && l.change(s, i);
      }
    ), { isSeeking: e, scrollSeekConfiguration: o, scrollSeekRangeChanged: n, scrollVelocity: t };
  },
  X(ae),
  { singleton: !0 }
), qe = U(([{ scrollContainerState: t, scrollTo: e }]) => {
  const n = $(), o = $(), r = $(), s = w(!1), i = w(void 0);
  return O(
    S(
      rt(n, o),
      E(([{ scrollHeight: l, scrollTop: c, viewportHeight: a }, { offsetTop: m }]) => ({
        scrollHeight: l,
        scrollTop: Math.max(0, c - m),
        viewportHeight: a
      }))
    ),
    t
  ), O(
    S(
      e,
      N(o),
      E(([l, { offsetTop: c }]) => ({
        ...l,
        top: l.top + c
      }))
    ),
    r
  ), {
    customScrollParent: i,
    // config
    useWindowScroll: s,
    // input
    windowScrollContainerState: n,
    // signals
    windowScrollTo: r,
    windowViewportRect: o
  };
}, X(at)), qo = U(
  ([
    { sizeRanges: t, sizes: e },
    { headerHeight: n, scrollTop: o },
    { initialTopMostItemIndex: r },
    { didMount: s },
    { useWindowScroll: i, windowScrollContainerState: l, windowViewportRect: c }
  ]) => {
    const a = $(), m = w(void 0), x = w(null), h = w(null);
    return O(l, x), O(c, h), K(
      S(
        a,
        N(e, o, i, x, h, n)
      ),
      ([I, C, v, g, p, u, T]) => {
        const b = Fo(C.sizeTree);
        g && p !== null && u !== null && (v = p.scrollTop - u.offsetTop), v -= T, I({ ranges: b, scrollTop: v });
      }
    ), O(S(m, A(We), E(Yo)), r), O(
      S(
        s,
        N(m),
        A(([, I]) => I !== void 0),
        Y(),
        E(([, I]) => I.ranges)
      ),
      t
    ), {
      getState: a,
      restoreStateFrom: m
    };
  },
  X(Et, at, ue, Pt, qe)
);
function Yo(t) {
  return { align: "start", index: 0, offset: t.scrollTop };
}
const Zo = U(([{ topItemsIndexes: t }]) => {
  const e = w(0);
  return O(
    S(
      e,
      A((n) => n >= 0),
      E((n) => Array.from({ length: n }).map((o, r) => r))
    ),
    t
  ), { topItemCount: e };
}, X($t));
function Zn(t) {
  let e = !1, n;
  return () => (e || (e = !0, n = t()), n);
}
const Xo = Zn(() => /iP(ad|od|hone)/i.test(navigator.userAgent) && /WebKit/i.test(navigator.userAgent)), Jo = U(
  ([
    { deviation: t, scrollBy: e, scrollingInProgress: n, scrollTop: o },
    { isAtBottom: r, isScrolling: s, lastJumpDueToItemResize: i, scrollDirection: l },
    { listState: c },
    { beforeUnshiftWith: a, gap: m, shiftWithOffset: x, sizes: h },
    { log: I },
    { recalcInProgress: C }
  ]) => {
    const v = ht(
      S(
        c,
        N(i),
        bt(
          ([, p, u, T], [{ bottom: b, items: f, offsetBottom: d, totalCount: y }, B]) => {
            const k = b + d;
            let L = 0;
            return u === y && p.length > 0 && f.length > 0 && (f[0].originalIndex === 0 && p[0].originalIndex === 0 || (L = k - T, L !== 0 && (L += B))), [L, f, y, k];
          },
          [0, [], 0, 0]
        ),
        A(([p]) => p !== 0),
        N(o, l, n, r, I, C),
        A(([, p, u, T, , , b]) => !b && !T && p !== 0 && u === le),
        E(([[p], , , , , u]) => (u("Upward scrolling compensation", { amount: p }, mt.DEBUG), p))
      )
    );
    function g(p) {
      p > 0 ? (G(e, { behavior: "auto", top: -p }), G(t, 0)) : (G(t, 0), G(e, { behavior: "auto", top: -p }));
    }
    return K(S(v, N(t, s)), ([p, u, T]) => {
      T && Xo() ? G(t, u - p) : g(-p);
    }), K(
      S(
        rt(ct(s, !1), t, C),
        A(([p, u, T]) => !p && !T && u !== 0),
        E(([p, u]) => u),
        kt(1)
      ),
      g
    ), O(
      S(
        x,
        E((p) => ({ top: -p }))
      ),
      e
    ), K(
      S(
        a,
        N(h, m),
        E(([p, { groupIndices: u, lastSize: T, sizeTree: b }, f]) => {
          function d(y) {
            return y * (T + f);
          }
          if (u.length === 0)
            return d(p);
          {
            let y = 0;
            const B = re(b, 0);
            let k = 0, L = 0;
            for (; k < p; ) {
              k++, y += B;
              let z = u.length === L + 1 ? 1 / 0 : u[L + 1] - u[L] - 1;
              k + z > p && (y -= B, z = p - k + 1), k += z, y += d(z), L++;
            }
            return y;
          }
        })
      ),
      (p) => {
        G(t, p), requestAnimationFrame(() => {
          G(e, { top: p }), requestAnimationFrame(() => {
            G(t, 0), G(C, !1);
          });
        });
      }
    ), { deviation: t };
  },
  X(at, ae, $t, Et, Vt, De)
), Qo = U(
  ([
    t,
    e,
    n,
    o,
    r,
    s,
    i,
    l,
    c,
    a,
    m
  ]) => ({
    ...t,
    ...e,
    ...n,
    ...o,
    ...r,
    ...s,
    ...i,
    ...l,
    ...c,
    ...a,
    ...m
  }),
  X(
    je,
    Ko,
    Pt,
    Yn,
    Kn,
    jo,
    No,
    qe,
    qn,
    Vt,
    jn
  )
), Xn = U(
  ([
    {
      data: t,
      defaultItemSize: e,
      firstItemIndex: n,
      fixedItemSize: o,
      gap: r,
      groupIndices: s,
      itemSize: i,
      sizeRanges: l,
      sizes: c,
      statefulTotalCount: a,
      totalCount: m,
      trackItemSizes: x
    },
    { initialItemFinalLocationReached: h, initialTopMostItemIndex: I, scrolledToInitialItem: C },
    v,
    g,
    p,
    { listState: u, topItemsIndexes: T, ...b },
    { scrollToIndex: f },
    d,
    { topItemCount: y },
    { groupCounts: B },
    k
  ]) => (O(b.rangeChanged, k.scrollSeekRangeChanged), O(
    S(
      k.windowViewportRect,
      E((L) => L.visibleHeight)
    ),
    v.viewportHeight
  ), {
    data: t,
    defaultItemHeight: e,
    firstItemIndex: n,
    fixedItemHeight: o,
    gap: r,
    groupCounts: B,
    initialItemFinalLocationReached: h,
    initialTopMostItemIndex: I,
    scrolledToInitialItem: C,
    sizeRanges: l,
    topItemCount: y,
    topItemsIndexes: T,
    // input
    totalCount: m,
    ...p,
    groupIndices: s,
    itemSize: i,
    listState: u,
    scrollToIndex: f,
    // output
    statefulTotalCount: a,
    trackItemSizes: x,
    // exported from stateFlagsSystem
    ...b,
    // the bag of IO from featureGroup1System
    ...k,
    ...v,
    sizes: c,
    ...g
  }),
  X(
    Et,
    ue,
    at,
    qo,
    Uo,
    $t,
    ce,
    Jo,
    Zo,
    Nn,
    Qo
  )
);
function tr(t, e) {
  const n = {}, o = {};
  let r = 0;
  const s = t.length;
  for (; r < s; )
    o[t[r]] = 1, r += 1;
  for (const i in e)
    Object.hasOwn(o, i) || (n[i] = e[i]);
  return n;
}
const pe = typeof document < "u" ? H.useLayoutEffect : H.useEffect;
function Ye(t, e, n) {
  const o = Object.keys(e.required || {}), r = Object.keys(e.optional || {}), s = Object.keys(e.methods || {}), i = Object.keys(e.events || {}), l = H.createContext({});
  function c(p, u) {
    p.propsReady && G(p.propsReady, !1);
    for (const T of o) {
      const b = p[e.required[T]];
      G(b, u[T]);
    }
    for (const T of r)
      if (T in u) {
        const b = p[e.optional[T]];
        G(b, u[T]);
      }
    p.propsReady && G(p.propsReady, !0);
  }
  function a(p) {
    return s.reduce((u, T) => (u[T] = (b) => {
      const f = p[e.methods[T]];
      G(f, b);
    }, u), {});
  }
  function m(p) {
    return i.reduce((u, T) => (u[T] = Io(p[e.events[T]]), u), {});
  }
  const x = H.forwardRef((p, u) => {
    const { children: T, ...b } = p, [f] = H.useState(() => ve(xo(t), (B) => {
      c(B, b);
    })), [d] = H.useState(an(m, f));
    pe(() => {
      for (const B of i)
        B in b && K(d[B], b[B]);
      return () => {
        Object.values(d).map(Ge);
      };
    }, [b, d, f]), pe(() => {
      c(f, b);
    }), H.useImperativeHandle(u, un(a(f)));
    const y = n;
    return /* @__PURE__ */ P(l.Provider, { value: f, children: n ? /* @__PURE__ */ P(y, { ...tr([...o, ...r, ...i], b), children: T }) : T });
  }), h = (p) => {
    const u = H.useContext(l);
    return H.useCallback(
      (T) => {
        G(u[p], T);
      },
      [u, p]
    );
  }, I = (p) => {
    const T = H.useContext(l)[p], b = H.useCallback(
      (f) => K(T, f),
      [T]
    );
    return H.useSyncExternalStore(
      b,
      () => ot(T),
      () => ot(T)
    );
  }, C = (p) => {
    const T = H.useContext(l)[p], [b, f] = H.useState(an(ot, T));
    return pe(
      () => K(T, (d) => {
        d !== b && f(un(d));
      }),
      [T, b]
    ), b;
  }, v = H.version.startsWith("18") ? I : C;
  return {
    Component: x,
    useEmitter: (p, u) => {
      const b = H.useContext(l)[p];
      pe(() => K(b, u), [u, b]);
    },
    useEmitterValue: v,
    usePublisher: h
  };
}
const be = H.createContext(void 0), Jn = H.createContext(void 0), Qn = typeof document < "u" ? H.useLayoutEffect : H.useEffect;
function ke(t) {
  return "self" in t;
}
function er(t) {
  return "body" in t;
}
function to(t, e, n, o = Yt, r, s) {
  const i = H.useRef(null), l = H.useRef(null), c = H.useRef(null), a = H.useCallback(
    (h) => {
      let I, C, v;
      const g = h.target;
      if (er(g) || ke(g)) {
        const u = ke(g) ? g : g.defaultView;
        v = s ? u.scrollX : u.scrollY, I = s ? u.document.documentElement.scrollWidth : u.document.documentElement.scrollHeight, C = s ? u.innerWidth : u.innerHeight;
      } else
        v = s ? g.scrollLeft : g.scrollTop, I = s ? g.scrollWidth : g.scrollHeight, C = s ? g.offsetWidth : g.offsetHeight;
      const p = () => {
        t({
          scrollHeight: I,
          scrollTop: Math.max(v, 0),
          viewportHeight: C
        });
      };
      h.suppressFlushSync ? p() : ao.flushSync(p), l.current !== null && (v === l.current || v <= 0 || v === I - C) && (l.current = null, e(!0), c.current && (clearTimeout(c.current), c.current = null));
    },
    [t, e, s]
  );
  H.useEffect(() => {
    const h = r || i.current;
    return o(r || i.current), a({ suppressFlushSync: !0, target: h }), h.addEventListener("scroll", a, { passive: !0 }), () => {
      o(null), h.removeEventListener("scroll", a);
    };
  }, [i, a, n, o, r]);
  function m(h) {
    const I = i.current;
    if (!I || (s ? "offsetWidth" in I && I.offsetWidth === 0 : "offsetHeight" in I && I.offsetHeight === 0))
      return;
    const C = h.behavior === "smooth";
    let v, g, p;
    ke(I) ? (g = Math.max(
      vt(I.document.documentElement, s ? "width" : "height"),
      s ? I.document.documentElement.scrollWidth : I.document.documentElement.scrollHeight
    ), v = s ? I.innerWidth : I.innerHeight, p = s ? window.scrollX : window.scrollY) : (g = I[s ? "scrollWidth" : "scrollHeight"], v = vt(I, s ? "width" : "height"), p = I[s ? "scrollLeft" : "scrollTop"]);
    const u = g - v;
    if (h.top = Math.ceil(Math.max(Math.min(u, h.top), 0)), $n(v, g) || h.top === p) {
      t({ scrollHeight: g, scrollTop: p, viewportHeight: v }), C && e(!0);
      return;
    }
    C ? (l.current = h.top, c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      c.current = null, l.current = null, e(!0);
    }, 1e3)) : l.current = null, s && (h = { behavior: h.behavior, left: h.top }), I.scrollTo(h);
  }
  function x(h) {
    s && (h = { behavior: h.behavior, left: h.top }), i.current.scrollBy(h);
  }
  return { scrollByCallback: x, scrollerRef: i, scrollToCallback: m };
}
const Fe = "-webkit-sticky", Tn = "sticky", Ze = Zn(() => {
  if (typeof document > "u")
    return Tn;
  const t = document.createElement("div");
  return t.style.position = Fe, t.style.position === Fe ? Fe : Tn;
});
function Xe(t) {
  return t;
}
const nr = /* @__PURE__ */ U(() => {
  const t = w((l) => `Item ${l}`), e = w((l) => `Group ${l}`), n = w({}), o = w(Xe), r = w("div"), s = w(Yt), i = (l, c = null) => ct(
    S(
      n,
      E((a) => a[l]),
      Y()
    ),
    c
  );
  return {
    components: n,
    computeItemKey: o,
    EmptyPlaceholder: i("EmptyPlaceholder"),
    FooterComponent: i("Footer"),
    GroupComponent: i("Group", "div"),
    groupContent: e,
    HeaderComponent: i("Header"),
    HeaderFooterTag: r,
    ItemComponent: i("Item", "div"),
    itemContent: t,
    ListComponent: i("List", "div"),
    ScrollerComponent: i("Scroller", "div"),
    scrollerRef: s,
    ScrollSeekPlaceholder: i("ScrollSeekPlaceholder"),
    TopItemListComponent: i("TopItemList")
  };
}), or = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(Xn, nr)
), rr = ({ height: t }) => /* @__PURE__ */ P("div", { style: { height: t } }), sr = { overflowAnchor: "none", position: Ze(), zIndex: 1 }, eo = { overflowAnchor: "none" }, ir = { ...eo, display: "inline-block", height: "100%" }, Cn = /* @__PURE__ */ H.memo(function({ showTopList: e = !1 }) {
  const n = M("listState"), o = gt("sizeRanges"), r = M("useWindowScroll"), s = M("customScrollParent"), i = gt("windowScrollContainerState"), l = gt("scrollContainerState"), c = s || r ? i : l, a = M("itemContent"), m = M("context"), x = M("groupContent"), h = M("trackItemSizes"), I = M("itemSize"), C = M("log"), v = gt("gap"), g = M("horizontalDirection"), { callbackRef: p } = On(
    o,
    I,
    h,
    e ? Yt : c,
    C,
    v,
    s,
    g,
    M("skipAnimationFrameInResizeObserver")
  ), [u, T] = H.useState(0);
  tn("deviation", (F) => {
    u !== F && T(F);
  });
  const b = M("EmptyPlaceholder"), f = M("ScrollSeekPlaceholder") || rr, d = M("ListComponent"), y = M("ItemComponent"), B = M("GroupComponent"), k = M("computeItemKey"), L = M("isSeeking"), z = M("groupIndices").length > 0, _ = M("alignToBottom"), J = M("initialItemFinalLocationReached"), nt = e ? {} : {
    boxSizing: "border-box",
    ...g ? {
      display: "inline-block",
      height: "100%",
      marginLeft: u !== 0 ? u : _ ? "auto" : 0,
      paddingLeft: n.offsetTop,
      paddingRight: n.offsetBottom,
      whiteSpace: "nowrap"
    } : {
      marginTop: u !== 0 ? u : _ ? "auto" : 0,
      paddingBottom: n.offsetBottom,
      paddingTop: n.offsetTop
    },
    ...J ? {} : { visibility: "hidden" }
  };
  return !e && n.totalCount === 0 && b ? /* @__PURE__ */ P(b, { ...Z(b, m) }) : /* @__PURE__ */ P(
    d,
    {
      ...Z(d, m),
      "data-testid": e ? "virtuoso-top-item-list" : "virtuoso-item-list",
      ref: p,
      style: nt,
      children: (e ? n.topItems : n.items).map((F) => {
        const q = F.originalIndex, it = k(q + n.firstItemIndex, F.data, m);
        return L ? /* @__PURE__ */ _t(
          f,
          {
            ...Z(f, m),
            height: F.size,
            index: F.index,
            key: it,
            type: F.type || "item",
            ...F.type === "group" ? {} : { groupIndex: F.groupIndex }
          }
        ) : F.type === "group" ? /* @__PURE__ */ _t(
          B,
          {
            ...Z(B, m),
            "data-index": q,
            "data-item-index": F.index,
            "data-known-size": F.size,
            key: it,
            style: sr
          },
          x(F.index, m)
        ) : /* @__PURE__ */ _t(
          y,
          {
            ...Z(y, m),
            ...no(y, F.data),
            "data-index": q,
            "data-item-group-index": F.groupIndex,
            "data-item-index": F.index,
            "data-known-size": F.size,
            key: it,
            style: g ? ir : eo
          },
          z ? a(F.index, F.groupIndex, F.data, m) : a(F.index, F.data, m)
        );
      })
    }
  );
}), lr = {
  height: "100%",
  outline: "none",
  overflowY: "auto",
  position: "relative",
  WebkitOverflowScrolling: "touch"
}, cr = {
  outline: "none",
  overflowX: "auto",
  position: "relative"
}, Zt = (t) => ({
  height: "100%",
  position: "absolute",
  top: 0,
  width: "100%",
  ...t ? { display: "flex", flexDirection: "column" } : {}
}), ur = {
  position: Ze(),
  top: 0,
  width: "100%",
  zIndex: 1
};
function Z(t, e) {
  if (typeof t != "string")
    return { context: e };
}
function no(t, e) {
  return { item: typeof t == "string" ? void 0 : e };
}
const ar = /* @__PURE__ */ H.memo(function() {
  const e = M("HeaderComponent"), n = gt("headerHeight"), o = M("HeaderFooterTag"), r = Ht(
    H.useMemo(
      () => (i) => {
        n(vt(i, "height"));
      },
      [n]
    ),
    !0,
    M("skipAnimationFrameInResizeObserver")
  ), s = M("context");
  return e ? /* @__PURE__ */ P(o, { ref: r, children: /* @__PURE__ */ P(e, { ...Z(e, s) }) }) : null;
}), dr = /* @__PURE__ */ H.memo(function() {
  const e = M("FooterComponent"), n = gt("footerHeight"), o = M("HeaderFooterTag"), r = Ht(
    H.useMemo(
      () => (i) => {
        n(vt(i, "height"));
      },
      [n]
    ),
    !0,
    M("skipAnimationFrameInResizeObserver")
  ), s = M("context");
  return e ? /* @__PURE__ */ P(o, { ref: r, children: /* @__PURE__ */ P(e, { ...Z(e, s) }) }) : null;
});
function Je({ useEmitter: t, useEmitterValue: e, usePublisher: n }) {
  return H.memo(function({ children: s, style: i, context: l, ...c }) {
    const a = n("scrollContainerState"), m = e("ScrollerComponent"), x = n("smoothScrollTargetReached"), h = e("scrollerRef"), I = e("horizontalDirection") || !1, { scrollByCallback: C, scrollerRef: v, scrollToCallback: g } = to(
      a,
      x,
      m,
      h,
      void 0,
      I
    );
    return t("scrollTo", g), t("scrollBy", C), /* @__PURE__ */ P(
      m,
      {
        "data-testid": "virtuoso-scroller",
        "data-virtuoso-scroller": !0,
        ref: v,
        style: { ...I ? cr : lr, ...i },
        tabIndex: 0,
        ...c,
        ...Z(m, l),
        children: s
      }
    );
  });
}
function Qe({ useEmitter: t, useEmitterValue: e, usePublisher: n }) {
  return H.memo(function({ children: s, style: i, context: l, ...c }) {
    const a = n("windowScrollContainerState"), m = e("ScrollerComponent"), x = n("smoothScrollTargetReached"), h = e("totalListHeight"), I = e("deviation"), C = e("customScrollParent"), v = H.useRef(null), g = e("scrollerRef"), { scrollByCallback: p, scrollerRef: u, scrollToCallback: T } = to(
      a,
      x,
      m,
      g,
      C
    );
    return Qn(() => {
      var b;
      return u.current = C || ((b = v.current) == null ? void 0 : b.ownerDocument.defaultView), () => {
        u.current = null;
      };
    }, [u, C]), t("windowScrollTo", T), t("scrollBy", p), /* @__PURE__ */ P(
      m,
      {
        ref: v,
        "data-virtuoso-scroller": !0,
        style: { position: "relative", ...i, ...h !== 0 ? { height: h + I } : {} },
        ...c,
        ...Z(m, l),
        children: s
      }
    );
  });
}
const fr = ({ children: t }) => {
  const e = H.useContext(be), n = gt("viewportHeight"), o = gt("fixedItemHeight"), r = M("alignToBottom"), s = M("horizontalDirection"), i = H.useMemo(
    () => ne(n, (c) => vt(c, s ? "width" : "height")),
    [n, s]
  ), l = Ht(i, !0, M("skipAnimationFrameInResizeObserver"));
  return H.useEffect(() => {
    e && (n(e.viewportHeight), o(e.itemHeight));
  }, [e, n, o]), /* @__PURE__ */ P("div", { "data-viewport-type": "element", ref: l, style: Zt(r), children: t });
}, mr = ({ children: t }) => {
  const e = H.useContext(be), n = gt("windowViewportRect"), o = gt("fixedItemHeight"), r = M("customScrollParent"), s = Ne(
    n,
    r,
    M("skipAnimationFrameInResizeObserver")
  ), i = M("alignToBottom");
  return H.useEffect(() => {
    e && (o(e.itemHeight), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: 100 }));
  }, [e, n, o]), /* @__PURE__ */ P("div", { "data-viewport-type": "window", ref: s, style: Zt(i), children: t });
}, pr = ({ children: t }) => {
  const e = M("TopItemListComponent") || "div", n = M("headerHeight"), o = { ...ur, marginTop: `${n}px` }, r = M("context");
  return /* @__PURE__ */ P(e, { style: o, ...Z(e, r), children: t });
}, hr = /* @__PURE__ */ H.memo(function(e) {
  const n = M("useWindowScroll"), o = M("topItemsIndexes").length > 0, r = M("customScrollParent"), s = M("context");
  return /* @__PURE__ */ Nt(r || n ? Ir : gr, { ...e, context: s, children: [
    o && /* @__PURE__ */ P(pr, { children: /* @__PURE__ */ P(Cn, { showTopList: !0 }) }),
    /* @__PURE__ */ Nt(r || n ? mr : fr, { children: [
      /* @__PURE__ */ P(ar, {}),
      /* @__PURE__ */ P(Cn, {}),
      /* @__PURE__ */ P(dr, {})
    ] })
  ] });
}), {
  Component: oo,
  useEmitter: tn,
  useEmitterValue: M,
  usePublisher: gt
} = /* @__PURE__ */ Ye(
  or,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      scrollIntoViewOnChange: "scrollIntoViewOnChange",
      itemContent: "itemContent",
      groupContent: "groupContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      groupCounts: "groupCounts",
      topItemCount: "topItemCount",
      firstItemIndex: "firstItemIndex",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "HeaderFooterTag",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      horizontalDirection: "horizontalDirection",
      skipAnimationFrameInResizeObserver: "skipAnimationFrameInResizeObserver"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      autoscrollToBottom: "autoscrollToBottom",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  hr
), gr = /* @__PURE__ */ Je({ useEmitter: tn, useEmitterValue: M, usePublisher: gt }), Ir = /* @__PURE__ */ Qe({ useEmitter: tn, useEmitterValue: M, usePublisher: gt }), qr = oo, Yr = oo, Sr = /* @__PURE__ */ U(() => {
  const t = w((a) => /* @__PURE__ */ Nt("td", { children: [
    "Item $",
    a
  ] })), e = w(null), n = w((a) => /* @__PURE__ */ Nt("td", { colSpan: 1e3, children: [
    "Group ",
    a
  ] })), o = w(null), r = w(null), s = w({}), i = w(Xe), l = w(Yt), c = (a, m = null) => ct(
    S(
      s,
      E((x) => x[a]),
      Y()
    ),
    m
  );
  return {
    components: s,
    computeItemKey: i,
    context: e,
    EmptyPlaceholder: c("EmptyPlaceholder"),
    FillerRow: c("FillerRow"),
    fixedFooterContent: r,
    fixedHeaderContent: o,
    itemContent: t,
    groupContent: n,
    ScrollerComponent: c("Scroller", "div"),
    scrollerRef: l,
    ScrollSeekPlaceholder: c("ScrollSeekPlaceholder"),
    TableBodyComponent: c("TableBody", "tbody"),
    TableComponent: c("Table", "table"),
    TableFooterComponent: c("TableFoot", "tfoot"),
    TableHeadComponent: c("TableHead", "thead"),
    TableRowComponent: c("TableRow", "tr"),
    GroupComponent: c("Group", "tr")
  };
}), xr = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(Xn, Sr)
), Tr = ({ height: t }) => /* @__PURE__ */ P("tr", { children: /* @__PURE__ */ P("td", { style: { height: t } }) }), Cr = ({ height: t }) => /* @__PURE__ */ P("tr", { children: /* @__PURE__ */ P("td", { style: { border: 0, height: t, padding: 0 } }) }), wr = { overflowAnchor: "none" }, wn = { position: Ze(), zIndex: 2, overflowAnchor: "none" }, vn = /* @__PURE__ */ H.memo(function({ showTopList: e = !1 }) {
  const n = W("listState"), o = W("computeItemKey"), r = W("firstItemIndex"), s = W("context"), i = W("isSeeking"), l = W("fixedHeaderHeight"), c = W("groupIndices").length > 0, a = W("itemContent"), m = W("groupContent"), x = W("ScrollSeekPlaceholder") || Tr, h = W("GroupComponent"), I = W("TableRowComponent"), C = (e ? n.topItems : []).reduce((g, p, u) => (u === 0 ? g.push(p.size) : g.push(g[u - 1] + p.size), g), []), v = (e ? n.topItems : n.items).map((g) => {
    const p = g.originalIndex, u = o(p + r, g.data, s), T = e ? p === 0 ? 0 : C[p - 1] : 0;
    return i ? /* @__PURE__ */ _t(
      x,
      {
        ...Z(x, s),
        height: g.size,
        index: g.index,
        key: u,
        type: g.type || "item"
      }
    ) : g.type === "group" ? /* @__PURE__ */ _t(
      h,
      {
        ...Z(h, s),
        "data-index": p,
        "data-item-index": g.index,
        "data-known-size": g.size,
        key: u,
        style: {
          ...wn,
          top: l
        }
      },
      m(g.index, s)
    ) : /* @__PURE__ */ _t(
      I,
      {
        ...Z(I, s),
        ...no(I, g.data),
        "data-index": p,
        "data-item-index": g.index,
        "data-known-size": g.size,
        "data-item-group-index": g.groupIndex,
        key: u,
        style: e ? { ...wn, top: l + T } : wr
      },
      c ? a(g.index, g.groupIndex, g.data, s) : a(g.index, g.data, s)
    );
  });
  return /* @__PURE__ */ P(uo, { children: v });
}), vr = /* @__PURE__ */ H.memo(function() {
  const e = W("listState"), n = W("topItemsIndexes").length > 0, o = Ct("sizeRanges"), r = W("useWindowScroll"), s = W("customScrollParent"), i = Ct("windowScrollContainerState"), l = Ct("scrollContainerState"), c = s || r ? i : l, a = W("trackItemSizes"), m = W("itemSize"), x = W("log"), { callbackRef: h, ref: I } = On(
    o,
    m,
    a,
    c,
    x,
    void 0,
    s,
    !1,
    W("skipAnimationFrameInResizeObserver")
  ), [C, v] = H.useState(0);
  en("deviation", (z) => {
    C !== z && (I.current.style.marginTop = `${z}px`, v(z));
  });
  const g = W("EmptyPlaceholder"), p = W("FillerRow") || Cr, u = W("TableBodyComponent"), T = W("paddingTopAddition"), b = W("statefulTotalCount"), f = W("context");
  if (b === 0 && g)
    return /* @__PURE__ */ P(g, { ...Z(g, f) });
  const d = (n ? e.topItems : []).reduce((z, _) => z + _.size, 0), y = e.offsetTop + T + C - d, B = e.offsetBottom, k = y > 0 ? /* @__PURE__ */ P(p, { context: f, height: y }, "padding-top") : null, L = B > 0 ? /* @__PURE__ */ P(p, { context: f, height: B }, "padding-bottom") : null;
  return /* @__PURE__ */ Nt(u, { "data-testid": "virtuoso-item-list", ref: h, ...Z(u, f), children: [
    k,
    n && /* @__PURE__ */ P(vn, { showTopList: !0 }),
    /* @__PURE__ */ P(vn, {}),
    L
  ] });
}), yr = ({ children: t }) => {
  const e = H.useContext(be), n = Ct("viewportHeight"), o = Ct("fixedItemHeight"), r = Ht(
    H.useMemo(() => ne(n, (s) => vt(s, "height")), [n]),
    !0,
    W("skipAnimationFrameInResizeObserver")
  );
  return H.useEffect(() => {
    e && (n(e.viewportHeight), o(e.itemHeight));
  }, [e, n, o]), /* @__PURE__ */ P("div", { "data-viewport-type": "element", ref: r, style: Zt(!1), children: t });
}, Rr = ({ children: t }) => {
  const e = H.useContext(be), n = Ct("windowViewportRect"), o = Ct("fixedItemHeight"), r = W("customScrollParent"), s = Ne(
    n,
    r,
    W("skipAnimationFrameInResizeObserver")
  );
  return H.useEffect(() => {
    e && (o(e.itemHeight), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: 100 }));
  }, [e, n, o]), /* @__PURE__ */ P("div", { "data-viewport-type": "window", ref: s, style: Zt(!1), children: t });
}, br = /* @__PURE__ */ H.memo(function(e) {
  const n = W("useWindowScroll"), o = W("customScrollParent"), r = Ct("fixedHeaderHeight"), s = Ct("fixedFooterHeight"), i = W("fixedHeaderContent"), l = W("fixedFooterContent"), c = W("context"), a = Ht(
    H.useMemo(() => ne(r, (u) => vt(u, "height")), [r]),
    !0,
    W("skipAnimationFrameInResizeObserver")
  ), m = Ht(
    H.useMemo(() => ne(s, (u) => vt(u, "height")), [s]),
    !0,
    W("skipAnimationFrameInResizeObserver")
  ), x = o || n ? Er : Hr, h = o || n ? Rr : yr, I = W("TableComponent"), C = W("TableHeadComponent"), v = W("TableFooterComponent"), g = i ? /* @__PURE__ */ P(
    C,
    {
      ref: a,
      style: { position: "sticky", top: 0, zIndex: 2 },
      ...Z(C, c),
      children: i()
    },
    "TableHead"
  ) : null, p = l ? /* @__PURE__ */ P(
    v,
    {
      ref: m,
      style: { bottom: 0, position: "sticky", zIndex: 1 },
      ...Z(v, c),
      children: l()
    },
    "TableFoot"
  ) : null;
  return /* @__PURE__ */ P(x, { ...e, ...Z(x, c), children: /* @__PURE__ */ P(h, { children: /* @__PURE__ */ Nt(I, { style: { borderSpacing: 0, overflowAnchor: "none" }, ...Z(I, c), children: [
    g,
    /* @__PURE__ */ P(vr, {}, "TableBody"),
    p
  ] }) }) });
}), {
  Component: ro,
  useEmitter: en,
  useEmitterValue: W,
  usePublisher: Ct
} = /* @__PURE__ */ Ye(
  xr,
  {
    required: {},
    optional: {
      restoreStateFrom: "restoreStateFrom",
      context: "context",
      followOutput: "followOutput",
      firstItemIndex: "firstItemIndex",
      itemContent: "itemContent",
      groupContent: "groupContent",
      fixedHeaderContent: "fixedHeaderContent",
      fixedFooterContent: "fixedFooterContent",
      overscan: "overscan",
      increaseViewportBy: "increaseViewportBy",
      totalCount: "totalCount",
      topItemCount: "topItemCount",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      components: "components",
      groupCounts: "groupCounts",
      atBottomThreshold: "atBottomThreshold",
      atTopThreshold: "atTopThreshold",
      computeItemKey: "computeItemKey",
      defaultItemHeight: "defaultItemHeight",
      fixedItemHeight: "fixedItemHeight",
      itemSize: "itemSize",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      data: "data",
      initialItemCount: "initialItemCount",
      initialScrollTop: "initialScrollTop",
      alignToBottom: "alignToBottom",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel"
    },
    methods: {
      scrollToIndex: "scrollToIndex",
      scrollIntoView: "scrollIntoView",
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      getState: "getState"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      totalListHeightChanged: "totalListHeightChanged",
      itemsRendered: "itemsRendered",
      groupIndices: "groupIndices"
    }
  },
  br
), Hr = /* @__PURE__ */ Je({ useEmitter: en, useEmitterValue: W, usePublisher: Ct }), Er = /* @__PURE__ */ Qe({ useEmitter: en, useEmitterValue: W, usePublisher: Ct }), Zr = ro, Xr = ro, yn = {
  bottom: 0,
  itemHeight: 0,
  items: [],
  itemWidth: 0,
  offsetBottom: 0,
  offsetTop: 0,
  top: 0
}, Br = {
  bottom: 0,
  itemHeight: 0,
  items: [{ index: 0 }],
  itemWidth: 0,
  offsetBottom: 0,
  offsetTop: 0,
  top: 0
}, { ceil: Rn, floor: Ce, max: ee, min: Oe, round: bn } = Math;
function Hn(t, e, n) {
  return Array.from({ length: e - t + 1 }).map((o, r) => ({ data: n === null ? null : n[r + t], index: r + t }));
}
function kr(t) {
  return {
    ...Br,
    items: t
  };
}
function he(t, e) {
  return t && t.width === e.width && t.height === e.height;
}
function Fr(t, e) {
  return t && t.column === e.column && t.row === e.row;
}
const Or = /* @__PURE__ */ U(
  ([
    { increaseViewportBy: t, listBoundary: e, overscan: n, visibleRange: o },
    { footerHeight: r, headerHeight: s, scrollBy: i, scrollContainerState: l, scrollTo: c, scrollTop: a, smoothScrollTargetReached: m, viewportHeight: x },
    h,
    I,
    { didMount: C, propsReady: v },
    { customScrollParent: g, useWindowScroll: p, windowScrollContainerState: u, windowScrollTo: T, windowViewportRect: b },
    f
  ]) => {
    const d = w(0), y = w(0), B = w(yn), k = w({ height: 0, width: 0 }), L = w({ height: 0, width: 0 }), z = $(), _ = $(), J = w(0), nt = w(null), F = w({ column: 0, row: 0 }), q = $(), it = $(), dt = w(!1), St = w(0), ft = w(!0), ut = w(!1), At = w(!1);
    K(
      S(
        C,
        N(St),
        A(([R, D]) => !!D)
      ),
      () => {
        G(ft, !1);
      }
    ), K(
      S(
        rt(C, ft, L, k, St, ut),
        A(([R, D, Q, lt, , tt]) => R && !D && Q.height !== 0 && lt.height !== 0 && !tt)
      ),
      ([, , , , R]) => {
        G(ut, !0), Ue(1, () => {
          G(z, R);
        }), Tt(S(a), () => {
          G(e, [0, 0]), G(ft, !0);
        });
      }
    ), O(
      S(
        it,
        A((R) => R != null && R.scrollTop > 0),
        Rt(0)
      ),
      y
    ), K(
      S(
        C,
        N(it),
        A(([, R]) => R != null)
      ),
      ([, R]) => {
        R && (G(k, R.viewport), G(L, R.item), G(F, R.gap), R.scrollTop > 0 && (G(dt, !0), Tt(S(a, Dt(1)), (D) => {
          G(dt, !1);
        }), G(c, { top: R.scrollTop })));
      }
    ), O(
      S(
        k,
        E(({ height: R }) => R)
      ),
      x
    ), O(
      S(
        rt(
          V(k, he),
          V(L, he),
          V(F, (R, D) => R && R.column === D.column && R.row === D.row),
          V(a)
        ),
        E(([R, D, Q, lt]) => ({
          gap: Q,
          item: D,
          scrollTop: lt,
          viewport: R
        }))
      ),
      q
    ), O(
      S(
        rt(
          V(d),
          o,
          V(F, Fr),
          V(L, he),
          V(k, he),
          V(nt),
          V(y),
          V(dt),
          V(ft),
          V(St)
        ),
        A(([, , , , , , , R]) => !R),
        E(
          ([
            R,
            [D, Q],
            lt,
            tt,
            Ft,
            Jt,
            Ut,
            ,
            de,
            Ot
          ]) => {
            const { column: Lt, row: Qt } = lt, { height: fe, width: He } = tt, { width: nn } = Ft;
            if (Ut === 0 && (R === 0 || nn === 0))
              return yn;
            if (He === 0) {
              const cn = Ke(Ot, R), co = cn + Math.max(Ut - 1, 0);
              return kr(Hn(cn, co, Jt));
            }
            const me = so(nn, He, Lt);
            let Kt, Wt;
            de ? D === 0 && Q === 0 && Ut > 0 ? (Kt = 0, Wt = Ut - 1) : (Kt = me * Ce((D + Qt) / (fe + Qt)), Wt = me * Rn((Q + Qt) / (fe + Qt)) - 1, Wt = Oe(R - 1, ee(Wt, me - 1)), Kt = Oe(Wt, ee(0, Kt))) : (Kt = 0, Wt = -1);
            const on = Hn(Kt, Wt, Jt), { bottom: rn, top: sn } = En(Ft, lt, tt, on), ln = Rn(R / me), lo = ln * fe + (ln - 1) * Qt - rn;
            return { bottom: rn, itemHeight: fe, items: on, itemWidth: He, offsetBottom: lo, offsetTop: sn, top: sn };
          }
        )
      ),
      B
    ), O(
      S(
        nt,
        A((R) => R !== null),
        E((R) => R.length)
      ),
      d
    ), O(
      S(
        rt(k, L, B, F),
        A(([R, D, { items: Q }]) => Q.length > 0 && D.height !== 0 && R.height !== 0),
        E(([R, D, { items: Q }, lt]) => {
          const { bottom: tt, top: Ft } = En(R, lt, D, Q);
          return [Ft, tt];
        }),
        Y(se)
      ),
      e
    );
    const xt = w(!1);
    O(
      S(
        a,
        N(xt),
        E(([R, D]) => D || R !== 0)
      ),
      xt
    );
    const Xt = ht(
      S(
        rt(B, d),
        A(([{ items: R }]) => R.length > 0),
        N(xt),
        A(([[R, D], Q]) => {
          const tt = R.items[R.items.length - 1].index === D - 1;
          return (Q || R.bottom > 0 && R.itemHeight > 0 && R.offsetBottom === 0 && R.items.length === D) && tt;
        }),
        E(([[, R]]) => R - 1),
        Y()
      )
    ), Mt = ht(
      S(
        V(B),
        A(({ items: R }) => R.length > 0 && R[0].index === 0),
        Rt(0),
        Y()
      )
    ), yt = ht(
      S(
        V(B),
        N(dt),
        A(([{ items: R }, D]) => R.length > 0 && !D),
        E(([{ items: R }]) => ({
          endIndex: R[R.length - 1].index,
          startIndex: R[0].index
        })),
        Y(Mn),
        kt(0)
      )
    );
    O(yt, I.scrollSeekRangeChanged), O(
      S(
        z,
        N(k, L, d, F),
        E(([R, D, Q, lt, tt]) => {
          const Ft = Dn(R), { align: Jt, behavior: Ut, offset: de } = Ft;
          let Ot = Ft.index;
          Ot === "LAST" && (Ot = lt - 1), Ot = ee(0, Ot, Oe(lt - 1, Ot));
          let Lt = Me(D, tt, Q, Ot);
          return Jt === "end" ? Lt = bn(Lt - D.height + Q.height) : Jt === "center" && (Lt = bn(Lt - D.height / 2 + Q.height / 2)), de && (Lt += de), { behavior: Ut, top: Lt };
        })
      ),
      c
    );
    const Bt = ct(
      S(
        B,
        E((R) => R.offsetBottom + R.bottom)
      ),
      0
    );
    return O(
      S(
        b,
        E((R) => ({ height: R.visibleHeight, width: R.visibleWidth }))
      ),
      k
    ), {
      customScrollParent: g,
      // input
      data: nt,
      deviation: J,
      footerHeight: r,
      gap: F,
      headerHeight: s,
      increaseViewportBy: t,
      initialItemCount: y,
      itemDimensions: L,
      overscan: n,
      restoreStateFrom: it,
      scrollBy: i,
      scrollContainerState: l,
      scrollHeight: _,
      scrollTo: c,
      scrollToIndex: z,
      scrollTop: a,
      smoothScrollTargetReached: m,
      totalCount: d,
      useWindowScroll: p,
      viewportDimensions: k,
      windowScrollContainerState: u,
      windowScrollTo: T,
      windowViewportRect: b,
      ...I,
      // output
      gridState: B,
      horizontalDirection: At,
      initialTopMostItemIndex: St,
      totalListHeight: Bt,
      ...h,
      endReached: Xt,
      propsReady: v,
      rangeChanged: yt,
      startReached: Mt,
      stateChanged: q,
      stateRestoreInProgress: dt,
      ...f
    };
  },
  X(je, at, ae, Yn, Pt, qe, Vt)
);
function so(t, e, n) {
  return ee(1, Ce((t + n) / (Ce(e) + n)));
}
function En(t, e, n, o) {
  const { height: r } = n;
  if (r === void 0 || o.length === 0)
    return { bottom: 0, top: 0 };
  const s = Me(t, e, n, o[0].index);
  return { bottom: Me(t, e, n, o[o.length - 1].index) + r, top: s };
}
function Me(t, e, n, o) {
  const r = so(t.width, n.width, e.column), s = Ce(o / r), i = s * n.height + ee(0, s - 1) * e.row;
  return i > 0 ? i + e.row : i;
}
const Lr = /* @__PURE__ */ U(() => {
  const t = w((x) => `Item ${x}`), e = w({}), n = w(null), o = w("virtuoso-grid-item"), r = w("virtuoso-grid-list"), s = w(Xe), i = w("div"), l = w(Yt), c = (x, h = null) => ct(
    S(
      e,
      E((I) => I[x]),
      Y()
    ),
    h
  ), a = w(!1), m = w(!1);
  return O(V(m), a), {
    components: e,
    computeItemKey: s,
    context: n,
    FooterComponent: c("Footer"),
    HeaderComponent: c("Header"),
    headerFooterTag: i,
    itemClassName: o,
    ItemComponent: c("Item", "div"),
    itemContent: t,
    listClassName: r,
    ListComponent: c("List", "div"),
    readyStateChanged: a,
    reportReadyState: m,
    ScrollerComponent: c("Scroller", "div"),
    scrollerRef: l,
    ScrollSeekPlaceholder: c("ScrollSeekPlaceholder", "div")
  };
}), zr = /* @__PURE__ */ U(
  ([t, e]) => ({ ...t, ...e }),
  X(Or, Lr)
), Vr = /* @__PURE__ */ H.memo(function() {
  const e = et("gridState"), n = et("listClassName"), o = et("itemClassName"), r = et("itemContent"), s = et("computeItemKey"), i = et("isSeeking"), l = It("scrollHeight"), c = et("ItemComponent"), a = et("ListComponent"), m = et("ScrollSeekPlaceholder"), x = et("context"), h = It("itemDimensions"), I = It("gap"), C = et("log"), v = et("stateRestoreInProgress"), g = It("reportReadyState"), p = Ht(
    H.useMemo(
      () => (u) => {
        const T = u.parentElement.parentElement.scrollHeight;
        l(T);
        const b = u.firstChild;
        if (b) {
          const { height: f, width: d } = b.getBoundingClientRect();
          h({ height: f, width: d });
        }
        I({
          column: Bn("column-gap", getComputedStyle(u).columnGap, C),
          row: Bn("row-gap", getComputedStyle(u).rowGap, C)
        });
      },
      [l, h, I, C]
    ),
    !0,
    !1
  );
  return Qn(() => {
    e.itemHeight > 0 && e.itemWidth > 0 && g(!0);
  }, [e]), v ? null : /* @__PURE__ */ P(
    a,
    {
      className: n,
      ref: p,
      ...Z(a, x),
      "data-testid": "virtuoso-item-list",
      style: { paddingBottom: e.offsetBottom, paddingTop: e.offsetTop },
      children: e.items.map((u) => {
        const T = s(u.index, u.data, x);
        return i ? /* @__PURE__ */ P(
          m,
          {
            ...Z(m, x),
            height: e.itemHeight,
            index: u.index,
            width: e.itemWidth
          },
          T
        ) : /* @__PURE__ */ _t(
          c,
          {
            ...Z(c, x),
            className: o,
            "data-index": u.index,
            key: T
          },
          r(u.index, u.data, x)
        );
      })
    }
  );
}), Pr = H.memo(function() {
  const e = et("HeaderComponent"), n = It("headerHeight"), o = et("headerFooterTag"), r = Ht(
    H.useMemo(
      () => (i) => {
        n(vt(i, "height"));
      },
      [n]
    ),
    !0,
    !1
  ), s = et("context");
  return e ? /* @__PURE__ */ P(o, { ref: r, children: /* @__PURE__ */ P(e, { ...Z(e, s) }) }) : null;
}), Ar = H.memo(function() {
  const e = et("FooterComponent"), n = It("footerHeight"), o = et("headerFooterTag"), r = Ht(
    H.useMemo(
      () => (i) => {
        n(vt(i, "height"));
      },
      [n]
    ),
    !0,
    !1
  ), s = et("context");
  return e ? /* @__PURE__ */ P(o, { ref: r, children: /* @__PURE__ */ P(e, { ...Z(e, s) }) }) : null;
}), Mr = ({ children: t }) => {
  const e = H.useContext(Jn), n = It("itemDimensions"), o = It("viewportDimensions"), r = Ht(
    H.useMemo(
      () => (s) => {
        o(s.getBoundingClientRect());
      },
      [o]
    ),
    !0,
    !1
  );
  return H.useEffect(() => {
    e && (o({ height: e.viewportHeight, width: e.viewportWidth }), n({ height: e.itemHeight, width: e.itemWidth }));
  }, [e, o, n]), /* @__PURE__ */ P("div", { ref: r, style: Zt(!1), children: t });
}, Wr = ({ children: t }) => {
  const e = H.useContext(Jn), n = It("windowViewportRect"), o = It("itemDimensions"), r = et("customScrollParent"), s = Ne(n, r, !1);
  return H.useEffect(() => {
    e && (o({ height: e.itemHeight, width: e.itemWidth }), n({ offsetTop: 0, visibleHeight: e.viewportHeight, visibleWidth: e.viewportWidth }));
  }, [e, n, o]), /* @__PURE__ */ P("div", { ref: s, style: Zt(!1), children: t });
}, Gr = /* @__PURE__ */ H.memo(function({ ...e }) {
  const n = et("useWindowScroll"), o = et("customScrollParent"), r = o || n ? Dr : Nr, s = o || n ? Wr : Mr, i = et("context");
  return /* @__PURE__ */ P(r, { ...e, ...Z(r, i), children: /* @__PURE__ */ Nt(s, { children: [
    /* @__PURE__ */ P(Pr, {}),
    /* @__PURE__ */ P(Vr, {}),
    /* @__PURE__ */ P(Ar, {})
  ] }) });
}), {
  Component: _r,
  useEmitter: io,
  useEmitterValue: et,
  usePublisher: It
} = /* @__PURE__ */ Ye(
  zr,
  {
    optional: {
      context: "context",
      totalCount: "totalCount",
      overscan: "overscan",
      itemContent: "itemContent",
      components: "components",
      computeItemKey: "computeItemKey",
      data: "data",
      initialItemCount: "initialItemCount",
      scrollSeekConfiguration: "scrollSeekConfiguration",
      headerFooterTag: "headerFooterTag",
      listClassName: "listClassName",
      itemClassName: "itemClassName",
      useWindowScroll: "useWindowScroll",
      customScrollParent: "customScrollParent",
      scrollerRef: "scrollerRef",
      logLevel: "logLevel",
      restoreStateFrom: "restoreStateFrom",
      initialTopMostItemIndex: "initialTopMostItemIndex",
      increaseViewportBy: "increaseViewportBy"
    },
    methods: {
      scrollTo: "scrollTo",
      scrollBy: "scrollBy",
      scrollToIndex: "scrollToIndex"
    },
    events: {
      isScrolling: "isScrolling",
      endReached: "endReached",
      startReached: "startReached",
      rangeChanged: "rangeChanged",
      atBottomStateChange: "atBottomStateChange",
      atTopStateChange: "atTopStateChange",
      stateChanged: "stateChanged",
      readyStateChanged: "readyStateChanged"
    }
  },
  Gr
), Nr = /* @__PURE__ */ Je({ useEmitter: io, useEmitterValue: et, usePublisher: It }), Dr = /* @__PURE__ */ Qe({ useEmitter: io, useEmitterValue: et, usePublisher: It });
function Bn(t, e, n) {
  return e !== "normal" && !(e != null && e.endsWith("px")) && n(`${t} was not resolved to pixel value correctly`, e, mt.WARN), e === "normal" ? 0 : parseInt(e != null ? e : "0", 10);
}
const Jr = _r;
export {
  Xr as GroupedTableVirtuoso,
  Yr as GroupedVirtuoso,
  mt as LogLevel,
  Zr as TableVirtuoso,
  qr as Virtuoso,
  Jr as VirtuosoGrid,
  Jn as VirtuosoGridMockContext,
  be as VirtuosoMockContext
};
